<template>
  <div class="mathRoad_container" ref="mathRoad_container">
    <div :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }">
      <img :src="getContainerBG" />
      <img class="bg_container" :src="getContainerBG_" />
    </div>
    <div class="mini_map_new" ref="miniMapBar">
      <a v-show="false" @click="switchMapType()">
        {{
        miniMap == "big" ? "区域" : "全局"
        }}
      </a>
      <!--a :class="{big_map:true, mapTypeSel:miniMap=='big'?true:false}" @click="switchMapType('big')">全局</a>
      <a :class="{small_map:true, mapTypeSel:miniMap=='small'?true:false}" @click="switchMapType('small')">区域</a>

      <a :class="{opacity_20:true, mapTypeSel:opacityVal>=20?true:false}" @click="switchOpacityVal(20)">20</a>
      <a :class="{opacity_40:true, mapTypeSel:opacityVal>=40?true:false}" @click="switchOpacityVal(40)">40</a>
      <a :class="{opacity_60:true, mapTypeSel:opacityVal>=60?true:false}" @click="switchOpacityVal(60)">60</a>
      <a :class="{opacity_80:true, mapTypeSel:opacityVal>=80?true:false}" @click="switchOpacityVal(80)">80</a>
      <a :class="{opacity_100:true, mapTypeSel:opacityVal>=100?true:false}" @click="switchOpacityVal(100)">100</a-->
    </div>
    <div class="father_bar">
      <div class="factory_bar" ref="factory" @click="goToPopup()">
        <p class="factory_title">{{ branchFactory }}</p>
        <template v-if="!noEquipBuilding">
          <p style="margin: 30px 0 0 5px">
            <span class="title_color">监测设备:</span>
            <!--template>TSP<span class="number">{{facotryMonitorDeviceList["TSP"]?facotryMonitorDeviceList["TSP"]:"-"}}</span>个，VDM<span
            class="number">{{facotryMonitorDeviceList["VDM"]?facotryMonitorDeviceList["VDM"]:"-"}}</span>个</p></template-->
            <span class="number">{{ monitorDeviceCount ? monitorDeviceCount : "-" }}</span>台
          </p>
          <p>
            <span class="title_color">生产设备:</span>
            <span class="number">
              {{
              productDeviceCount ? productDeviceCount : "-"
              }}
            </span>台
            <span class="title_color">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;治理设备:</span>
            <span class="number">
              {{
              governmentDeviceCount ? governmentDeviceCount : "-"
              }}
            </span>台
          </p>
          <!--p><span class="title_color">排放源点: </span><span class="number">{{emissionSourceCount}}</span>个
          </p-->
          <p style="margin-top: 30px">
            <span class="title_color">当日闭环事件管理:</span>
          </p>
          <div class="treatment_bar">
            发生
            <span style="color: #50eafb" class="number">
              {{
              workTicketCount ? workTicketCount : "-"
              }}
            </span>项， 执行
            <span style="color: #50eafb" class="number">
              {{
              treatmentCount ? treatmentCount : "-"
              }}
            </span>项
            <br />
            <span v-if="treatmentRate || treatmentRate != '-'">执行率:</span>
            <span style="color: #50eafb" class="number">{{ treatmentRate }}</span>
          </div>
        </template>
        <template v-else>
          <p style="margin-top: 20px">
            <span class="title_color">配套生产工艺设备:</span>
            <span class="description">{{ description }}</span>
          </p>
        </template>
        <!--p><span class="title_color">监测设备: </span>TSP<span class="number">{{facotryMonitorDeviceList["TSP"]}}</span>个， VDM<span class="number">{{facotryMonitorDeviceList["VDM"]}}</span>个</p>
        <p><span class="title_color">生产设备: </span><span class="number">{{productDeviceCount}}</span>台 <span class="title_color">治理设备: </span><span class="number">{{governmentDeviceCount}}</span>台</p>
        <p style="color:#63BD93;"><span class="title_color">当月闭环管理事件: </span>发生<span style="color:#63BD93;" class="number">{{workTicketCount}}</span>项， <span v-if="workTicketCount!=0">执行率:
        {{treatmentRate}}</span></p-->
      </div>
      <div class="alarm_bar" ref="alarm" @click="getEmissionTable()">
        <div class="alarm_inner">
          <!--p style="text-align:center; font-size:28px; margin-top: -10px"><span class="emission_bar number">{{emissionSourceCount}}</span>排放源点(个)</p-->
          <p>
            <span class="title_color">配套生产工艺设备:</span>
            <span class="description">{{ description }}</span>
          </p>
          <p class="emission_img"></p>
          <div class="emission_alarm">
            <span class="emission_bar number">{{ emissionSourceCount }}</span>
            <br />
            <span>排放源点(个)</span>
          </div>
        </div>
      </div>
      <div class="factorySub_bar" ref="factorySub" v-show="!reportTypeKey || reportTypeKey == 'auto'">
        <div class="warn_inner">
          <div class="warn_content">
            <p>
              <span class="warn_label">触发位置:</span>
              <span class="warn_val">
                {{
                resultScroll.deviceName ? resultScroll.deviceName : "-"
                }}
              </span>
            </p>
            <p>
              <span class="warn_label">风险类别:</span>
              <span class="warn_val">
                {{
                resultScroll.eventName
                ? resultScroll.eventName
                .replace(/超标告警/g, "告警")
                .replace(/超标/g, "告警")
                : "-"
                }}
              </span>
            </p>
            <p style="margin-left: 19px">
              <span class="warn_label">报警值:</span>
              <span class="warn_val">
                {{
                (resultScroll.value && resultScroll.value.toFixed
                ? resultScroll.value.toFixed(2)
                : "-") + (resultScroll.unit ? resultScroll.unit : "-")
                }}
              </span>
            </p>
            <p>
              <span class="warn_label">发生时间:</span>
              <span class="warn_val">
                {{
                resultScroll.time ? resultScroll.time : "-"
                }}
              </span>
            </p>
            <p>
              <span class="warn_label">设备编号:</span>
              <span class="warn_val">
                {{
                resultScroll.deviceNo ? resultScroll.deviceNo : "-"
                }}
              </span>
            </p>
          </div>
        </div>
        <!--warn ref="resultWarn" v-if="resultWarnTypeId && resultWarnObj" :data="resultWarnObj" :typeId="resultWarnTypeId"></warn-->
        <!--p style="color:#63BD93;"><span class="title_color">当月闭环管理事件: </span>发生<span style="color:#63BD93;" class="number">{{workTicketCount}}</span>项， <span v-if="workTicketCount!=0">执行率:
        {{treatmentRate}}</span></p-->
      </div>

      <div class="road_bar" ref="roadBar" @click="switchAutoVision()">
        <div class="road_bar_bg"></div>
        <div class="road_name" :style="{ color: isOrbitVision ? 'darkOrange' : '#ffff00' }">{{ roadName }}</div>
      </div>

      <div class="nearly_person" @click="nearlyPerson()">
        <div scrollamount="0">{{ "附近值班人员：" + onlinePersonStr? onlinePersonStr+ "等" + randomPerson.length + "人":onlinePersonStr + "人" }}</div>
      </div>
      <div class="nearly_car" @click="nearlyCar()">
        <div scrollamount="0">{{ "当前在线司机：" + cleanCars.length + "人" }}</div>
      </div>

      <div class="emission_table_vision">
        <el-table
          :data="sourceData"
          :header-cell-class-name="getHeaderCellClass"
          :header-row-class-name="getHeadRowClass"
          :cell-class-name="getCellClass"
          :row-class-name="getRowClass"
          class="source_table"
          ref="sourceTable"
          v-loading="isLoad"
          :element-loading-text="loadStr"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
          :style="{ marginTop: '10px' }"
          :maxHeight="autoHeight"
          @row-click="rowClick"
          empty-text="--"
        >
          <el-table-column type="index" label="序号" width="45"></el-table-column>
          <el-table-column label="分厂/所属区域" width="130">
            <span>{{ branchFactory }}</span>
          </el-table-column>
          <el-table-column prop="emission_source_name" label="排放源名称" width></el-table-column>
          <el-table-column align="center" header-align="center" label="关联生产设备" width="80">
            <template #default="scope">
              <span v-if="scope.row && scope.row.production_no == '1'" class="green-dot">●</span>
              <span
                v-else-if="
                  scope.row &&
                  (scope.row.production_no === 0 || scope.row.production_no === '0')
                "
                class="red-dot"
              >●</span>
              <span v-else-if="scope.row && isNaN(scope.row.production_no)" :title="scope.row.production_no" class="gray-dot">-</span>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" label="关联治理设备" width="80">
            <template #default="scope">
              <span v-if="scope.row && scope.row.government_no == '1'" class="green-dot">●</span>
              <span
                v-else-if="
                  scope.row &&
                  (scope.row.government_no === 0 || scope.row.government_no === '0')
                "
                class="red-dot"
              >●</span>
              <span v-else-if="scope.row && isNaN(scope.row.government_no)" :title="scope.row.government_no" class="gray-dot">-</span>
            </template>
          </el-table-column>
          <el-table-column align="center" header-align="center" label="关联监测设备" width="80">
            <template #default="scope">
              <span v-if="scope.row && scope.row.monitor_no == '1'" class="green-dot">●</span>
              <span
                v-else-if="
                  scope.row &&
                  (scope.row.monitor_no === 0 || scope.row.monitor_no === '0')
                "
                class="red-dot"
              >●</span>
              <span v-else-if="scope.row && isNaN(scope.row.monitor_no)" :title="scope.row.monitor_no" class="gray-dot">-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <device-bar ref="deviceBarVision" v-if="deviceStatus"></device-bar>
      <!--div class="factory_bar_shadow yy"></div-->
      <!--warn ref="warn" v-if="typeId && warnObj" :data="warnObj" :typeId="typeId"></warn-->
      <div class="factorySub_bar" ref="warn">
        <div class="warn_inner">
          <div class="warn_content">
            <p>
              <span class="warn_label">触发位置:</span>
              <span class="warn_val">
                {{
                warnObj.deviceName ? warnObj.deviceName : "-"
                }}
              </span>
            </p>
            <p>
              <span class="warn_label">风险类别:</span>
              <span class="warn_val">
                {{
                warnObj.eventName
                ? warnObj.eventName
                .replace(/超标告警/g, "告警")
                .replace(/超标/g, "告警")
                : "-"
                }}
              </span>
            </p>
            <p style="margin-left: 19px">
              <span class="warn_label">报警值:</span>
              <span class="warn_val">
                {{
                (warnObj.value ? warnObj.value : "-") +
                (warnObj.unit ? warnObj.unit : "-")
                }}
              </span>
            </p>
            <p>
              <span class="warn_label">发生时间:</span>
              <span class="warn_val">{{ warnObj.time ? warnObj.time : "-" }}</span>
            </p>
            <p style="text-align: center">
              <span class="warn_label">设备编号:</span>
              <span class="warn_label">
                {{
                warnObj.deviceNo ? warnObj.deviceNo : "-"
                }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="report" v-show="agoraStatus && reportShow">
        <div class="fleft">
          <div ref="reportBar" class="sliderReport slider_circle_10">
            <div v-for="(item, n) in reportResult" v-bind:key="n">
              <div class="warn1_title">
                <div
                  class="popup-type1-title"
                  :class="{
                    'popup-type1-title_green': getWarnType(item.handleState),
                  }"
                >
                  <template v-if="item.analyzeResult && item.warnType == 5">{{ "道路" }}-{{ "污染识别" }}</template>
                  <template v-else>
                    {{ item.typeName }}-{{
                    item.metric +
                    (item.warnType === 1 && item.metric === "TSP"
                    ? "告警"
                    : item.warnType === 1 && item.metric === "VDM浓度"
                    ? "告警"
                    : item.warnType === 1
                    ? "超标"
                    : item.warnType === 2
                    ? "超低"
                    : "")
                    }}
                  </template>
                </div>
                <div class="popup-type1-time">{{ formatTimeVal(item.eventTime) }}</div>
              </div>
              <div class="warn1_content">
                <div class="warn1_state">
                  闭环控制状态:
                  <span class="done_green">{{ item.desc }}</span>
                </div>
                <div class="warn1_position">
                  发生位置:
                  <span>{{ item.deviceName }}</span>
                </div>
                <template v-if="item.warnType == 5">
                  <div class="warn1_road_info">
                    统计时间:
                    <span>
                      {{ item.analyzeResult.startTime }} ~
                      {{
                      item.analyzeResult.endTime
                      ? item.analyzeResult.endTime.slice(11, 19)
                      : ""
                      }}
                    </span>
                  </div>
                  <div class="warn1_road_info">
                    全厂PM10均值:
                    <span>
                      {{
                      item.analyzeResult.pm10AvgFactory
                      ? item.analyzeResult.pm10AvgFactory
                      : "--"
                      }}
                      μg/m³
                    </span>
                  </div>
                  <div class="warn1_road_info">
                    PM10均值:
                    <span>
                      {{
                      item.analyzeResult.pm10AvgRoad
                      ? item.analyzeResult.pm10AvgRoad
                      : "--"
                      }}
                      μg/m³
                    </span>
                  </div>
                  <div class="warn1_road_info" v-if="item.analyzeResult && item.analyzeResult.vdmAvgRoad">
                    VDM均值:
                    <span>{{ item.analyzeResult.vdmAvgRoad }} μg/m³</span>
                  </div>
                </template>
                <template v-if="item.warnType != 5">
                  <div class="warn1_box">
                    <div class="smallBox">
                      <div class="warn1_type_name">{{ item.metric }}</div>
                      <div class="warn1_type_num">{{ item.value }}</div>
                      <div class="warn1_type_unit">{{ item.unit }}</div>
                    </div>
                  </div>
                </template>
                <template v-if="item.inChargeUsers">
                  <div class="warn1_treatmentBox">
                    责任人:
                    <template v-bind:key="idx" v-for="(item_, idx) in item.inChargeUsers">
                      <span v-if="idx < 6" class="warn1_treatment">
                        {{
                        item_.name
                        }}
                      </span>
                    </template>
                  </div>
                </template>
              </div>
            </div>
            <div class="next_button"></div>
            <div class="prev_button"></div>
          </div>
        </div>
      </div>

      <div v-if="agoraStatus" class="Microphone-bar">
        <div class="headIcon-bar">
          <img class="headIcon" src="./img/head-icon_.png" />
        </div>
        <div id="Microphone" v-show="false"></div>
        <div class="order-content">
          <div>
            <span class="name">小美</span>
            <br />
            <span ref="microStatusBar" class="content hide">在的。</span>
            <br />
            <marquee class="o_txt" scrollamount="15"></marquee>
            <!--input type="text"  placeholder="" /-->
          </div>
        </div>
      </div>

      <div v-if="agoraStatus && false" class="send">
        <div class="s_fiter">
          <!--<div class="s_con">-->
          <input type="text" class="s_txt" placeholder="请输入指令" />
          <div class="s_sub"></div>
          <!--<input type="button" value="发送" class="s_sub"/>-->
          <!--</div>-->
        </div>
      </div>

      <warn v-if="resultWarnTypeId" ref="resultWarn" class="warnTicket" :data="resultWarnObj" :typeId="resultWarnTypeId"></warn>
    </div>

    <div v-show="agoraStatus && contactShow" class="contactList" id="slider">
      <div class="contactType_title" v-html="'通讯录 - ' + contactTypeCN"></div>
      <div class="switch-bar" @click="switchContact()">
        {{ contactType == "online" ? "" : ""
        }}
        <img class="switch" src="./img/switch.png" />
      </div>
      <div class="closeContact" @click="closeContact()"></div>
      <div class="slider-content">
        <ul>
          <template v-bind:key="key + '-' + index" v-for="(value, key, index) in phoneBook">
            <li v-if="value.length > 0" :id="key">
              <a :name="key" class="title">{{ key }}</a>
              <ul>
                <li style="height: 82px; background: rgba(20, 41, 118, 0.43)" v-for="(item, n) in value" v-bind:key="n">
                  <a @click="agoraRTM_call(item.account, item.name)" href="javascript:void(0)">
                    <img class="person-icon" src="./img/person_icon.png" />
                    <span class="person-name">{{ item.name }}</span>
                    <template v-if="item.status != 0">
                      <span class="isOnLine">{{ "在线" }}</span>
                    </template>
                    <template v-else>
                      <span class="notOnLine">{{ "离线" }}</span>
                    </template>
                    <img class="person-phone" src="./img/phone-icon.png" />
                    <span class="person-pos">部门:</span>
                    <span class="person-posVal">
                      {{
                      item.department ? item.department : "--"
                      }}
                    </span>
                  </a>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div v-show="agoraStatus && specialContactShow" class="specialContactList" id="slider">
      <div class="contactType_title" v-html="'通讯录 - ' + specialContactTypeCN"></div>
      <div class="switch-bar" @click="switchSpecialContact()">
        {{ specialContactType == "nearly" ? "" : ""
        }}
        <img class="switch" src="./img/switch.png" />
      </div>
      <div class="closeContact" @click="closeSpecialContact()"></div>
      <div class="slider-content">
        <ul>
          <template v-bind:key="key + '-' + index" v-for="(value, key, index) in specialPhoneBook">
            <li v-if="value.length > 0" :id="key">
              <a :name="key" class="title">{{ key }}</a>
              <ul>
                <li style="height: 82px" v-for="(item, n) in value" v-bind:key="n">
                  <a @click="agoraRTM_call(item.account, item.name)" href="javascript:void(0)">
                    <img class="person-icon" src="./img/person_icon.png" />
                    <span class="person-name">{{ item.name }}</span>
                    <template v-if="item.status != 0">
                      <span class="isOnLine">{{ "在线" }}</span>
                    </template>
                    <template v-else>
                      <span class="notOnLine">{{ "离线" }}</span>
                    </template>
                    <img class="person-phone" src="./img/phone-icon.png" />
                    <span class="person-pos" v-html="specialContactType == 'nearly' ? '部门:' : '司机'"></span>
                    <span class="person-posVal" v-show="specialContactType == 'nearly'">
                      {{
                      item.department ? item.department : "--"
                      }}
                    </span>
                  </a>
                </li>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="reportList" v-if="agoraStatus && reportListShow && reportAddressDetail">
      <div
        class="reportAddress"
        :style="{ right: openReport ? '450px' : '1105px' }"
        v-show="reportHistoryList && reportHistoryList.length > 0 && !isSpecial"
      >
        <div class="swiper-slide-bar reportHistory" style="width: 485px">
          <div class="famous_school_item">
            <div class="famous_school_item_inner">
              <div ref="addressRouterReportDetail" class="famous_school_item_swiper" style="padding: 5px 5px 10px 10px" id="review_box">
                <div class="swiper-container">
                  <div class="swiper-wrapper" style="padding-right: 30px">
                    <div></div>
                    <template v-for="(item, n) in reportHistoryList" v-bind:key="n">
                      <div class="swiper-slide" style="width: 350px" @click="searchReportDetial(item.indexVal, item.areaIds, item.id)">
                        <a href="javascript:void(0)" class="famous_school_item_slide">
                          <!--div class="popup-type1-idx">{{ n + 1 }}</div-->
                          <div style="position: relative; margin-left: 20px">
                            <div class="reportTitle" style="display: block; font-size: 20px; font-weight: bolder">{{ countTitle(item) }}</div>
                            <div class="reportTitle" style="display: block; font-size: 18px">
                              开始时间:
                              <span>{{ item.startTime }}</span>
                            </div>
                            <div class="reportTitle" style="display: block; font-size: 18px">
                              结束时间:
                              <span>{{ item.endTime }}</span>
                            </div>
                            <div class="reportTitle" style="display: block; font-size: 18px">
                              巡查点位:
                              <template v-if="item.checkNum < item.totalAreasNum">
                                <span style="color: darkOrange">{{ item.checkNum }}</span>
                              </template>
                              <template v-else>
                                <span>{{ item.checkNum }}</span>
                              </template>
                              /
                              <span style="color: #fff">{{ item.totalAreasNum }}</span>
                            </div>
                            <a class="moreEmissionBtn" @click="moreEmissionReport(countTitle(item))">查看报告</a>
                          </div>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="swiper-slide-bar" v-show="reportDetail">
        <div class="famous_school_item">
          <div class="famous_school_item_inner">
            <div class="famous_school_item_top" v-show="false">
              <h3>巡查报告</h3>
            </div>
            <div ref="definedRouterReportDetail" class="famous_school_item_swiper" id="review_box">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, n) in reportResult" v-bind:key="n">
                    <a href="javascript:void(0)" class="famous_school_item_slide">
                      <div class="popup-type1-idx">{{ n + 1 }}</div>
                      <template v-if="item.inChargeUsers && item.inChargeUsers.length > 0">
                        <div class="warn1_treatmentBox">
                          <template v-bind:key="idx" v-for="(item_, idx) in item.inChargeUsers">
                            <span @click="agoraRTM_call_CN(item_.name)" v-if="idx < 1" class="warn1_treatment">
                              {{ item_.name
                              }}
                              <img class="person-phone" src="./img/phone-icon.png" />
                            </span>
                          </template>
                        </div>
                      </template>
                      <template v-else>
                        <div class="warn1_treatmentBox">
                          <span @click="agoraRTM_call_CN('陈雪建')" class="warn1_treatment">
                            <img class="person-phone" src="./img/phone-icon.png" />
                            {{
                            "陈雪建"
                            }}
                          </span>
                        </div>
                      </template>
                      <div class="warn1_title">
                        <div
                          class="popup-type1-title"
                          :class="{
                            'popup-type1-title_green': getWarnType(item.handleState),
                          }"
                        >
                          <template v-if="item.analyzeResult && item.warnType == 5">{{ "道路" }}-{{ "污染识别" }}</template>
                          <template v-else>
                            {{ item.eventName }}
                            <br />
                            {{ item.typeName }}
                          </template>
                        </div>
                        <div class="popup-type1-time">{{ formatTimeVal(item.eventTime) }}</div>
                        <div class="warn1_state">
                          闭环控制状态:
                          <span class="done_green">{{ item.desc }}</span>
                        </div>
                        <div class="warn1_position">
                          发生位置:
                          <span>{{ item.deviceName }}</span>
                        </div>
                      </div>
                      <div v-if="false" class="warn1_content">
                        <template v-if="item.warnType == 5">
                          <div class="warn1_road_info">
                            统计时间:
                            <span>
                              {{ item.analyzeResult.startTime }} ~
                              {{
                              item.analyzeResult.endTime
                              ? item.analyzeResult.endTime.slice(11, 19)
                              : ""
                              }}
                            </span>
                          </div>
                          <div class="warn1_road_info">
                            全厂PM10均值:
                            <span>
                              {{
                              item.analyzeResult.pm10AvgFactory
                              ? item.analyzeResult.pm10AvgFactory
                              : "--"
                              }}
                              μg/m³
                            </span>
                          </div>
                          <div class="warn1_road_info">
                            PM10均值:
                            <span>
                              {{
                              item.analyzeResult.pm10AvgRoad
                              ? item.analyzeResult.pm10AvgRoad
                              : "--"
                              }}
                              μg/m³
                            </span>
                          </div>
                          <div class="warn1_road_info" v-if="item.analyzeResult && item.analyzeResult.vdmAvgRoad">
                            VDM均值:
                            <span>{{ item.analyzeResult.vdmAvgRoad }} μg/m³</span>
                          </div>
                        </template>
                        <template v-if="item.warnType != 5">
                          <div class="warn1_box">
                            <div class="smallBox">
                              <div class="warn1_type_name">{{ item.metric }}</div>
                              <div class="warn1_type_num">{{ item.value }}</div>
                              <div class="warn1_type_unit">{{ item.unit }}</div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="customBrief()" class="return-btn"></div>
      </div>

      <div class="report-bar" v-show="!reportDetail && !openReport">
        <div class="swiper-slide">
          <a @click="closeReport()" class="closeReport"></a>
          <a href="javascript:void(0)" class="famous_school_item_slide reportTitle">
            <font style="font-size: 22px; line-height: 50px">{{ reportType }}</font>
            <div class="reportRouteSetting" @click="openRouteSetting"></div>
            <br />开始时间：
            <span>{{ reportSearchTime }}</span>，
            <br />状态：
            <font style="color: #2febff" v-html="reportSearchStatus ? '完成' : '进行中...'"></font>
            <br />
            {{
            reportFactoryList.length > 0
            ? "巡查路线覆盖了" + reportFactoryStr + "等"
            : "巡查点位:"
            }}
            <span>
              {{
              reportFactoryCNList.length > 0 ? reportFactoryCNList.length : ""
              }}
            </span>
            {{ reportFactoryList.length > 0 ? "个分厂点位" : ""
            }}
            <font style="color: #2febff">
              {{
              reportFactoryList.length > 0 ? "" : reportFactoryStr
              }}
            </font>,
            <br />共发现
            <span>{{ reportResult.length }}</span>
            条告警
            <a v-show="reportResult && reportResult.length > 0" @click="customReadMore()" class="moreReport">查看更多</a>
          </a>
          <!-- <a class="moreEmissionBtn" v-if="!isSpecial" @click="moreEmissionReport()"
            >查看报告</a
          >-->
        </div>
        <div class="swiper-slide-bar_">
          <div class="famous_school_item">
            <div class="famous_school_item_inner">
              <a
                class="switch-btn_"
                v-show="!isSpecial"
                href="javascript: void(0)"
                @click="switchReport(true)"
                ref="switchBtn"
                :class="{ 'switch-btn-active': !showReport }"
              >闭环工单</a>
              <a
                class="switch-btn"
                href="javascript: void(0)"
                @click="switchReport(false)"
                ref="switchBtnS"
                v-show="reportSearchStatus && !isSpecial"
                :class="{
                  'switch-btn-active': showReport,
                }"
                :style="{
                  'margin-left': '120px',
                }"
              >巡检记录</a>
              <div class="famous_school_item_top" v-show="false">
                <h3>巡查报告</h3>
              </div>
              <div ref="definedRouterReport" class="famous_school_item_swiper" id="review_box">
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <img
                      class="empty-warn"
                      src="./img/empty.png"
                      v-show="
                        (!showReport && (!reportResult || reportResult.length == 0)) ||
                        (isSpecial && (!reportResult || reportResult.length == 0))
                      "
                    />
                    <div
                      class="empty-warn-font"
                      v-show="
                        (!showReport && (!reportResult || reportResult.length == 0)) ||
                        (isSpecial && (!reportResult || reportResult.length == 0))
                      "
                    >没有报警数据</div>

                    <template v-if="showReport && !isSpecial">
                      <div v-if="reportSearchStatus" style="font-size: 22px">
                        <div class="emissionReportBrief" style="margin-top: 30px">
                          生产工艺过程 :
                          <br />
                          <span style="margin-left: 40px">巡查通过(</span>
                          <span
                            class="number"
                            :style="{
                              color: emissionReport1.success > 0 ? '#2febff' : '#fff',
                            }"
                          >{{ emissionReport1.success }}</span>
                          <span>)个排放源点位;</span>
                          <template v-if="emissionReport1.error && emissionReport1.error > 0">
                            <br />
                            <span style="margin-left: 40px">问题点位(</span>
                            <span
                              class="number"
                              :style="{
                                color: emissionReport1.error > 0 ? '#f00' : '#fff',
                              }"
                            >{{ emissionReport1.error }}</span>
                            <span>)</span>
                          </template>
                        </div>
                        <div class="emissionReportBrief" style="margin-top: 20px">
                          物料封闭运输 :
                          <br />
                          <span style="margin-left: 40px">巡查通过(</span>
                          <span
                            class="number"
                            :style="{
                              color: emissionReport2.success > 0 ? '#2febff' : '#fff',
                            }"
                          >{{ emissionReport2.success }}</span>
                          <span>)个排放源点位;</span>
                          <template v-if="emissionReport2.error && emissionReport2.error > 0">
                            <br />
                            <span style="margin-left: 40px">问题点位(</span>
                            <span
                              class="number"
                              :style="{
                                color: emissionReport2.error > 0 ? '#f00' : '#fff',
                              }"
                            >{{ emissionReport2.error }}</span>
                            <span>)</span>
                          </template>
                        </div>
                        <div class="emissionReportBrief" style="margin-top: 20px">
                          物料封闭储存 :
                          <br />
                          <span style="margin-left: 40px">巡查通过(</span>
                          <span
                            class="number"
                            :style="{
                              color: emissionReport3.success > 0 ? '#2febff' : '#fff',
                            }"
                          >{{ emissionReport3.success }}</span>
                          <span>)个排放源点位;</span>
                          <template v-if="emissionReport3.error && emissionReport3.error > 0">
                            <br />
                            <span style="margin-left: 40px">问题点位(</span>
                            <span
                              class="number"
                              :style="{
                                color: emissionReport3.error > 0 ? '#f00' : '#fff',
                              }"
                            >{{ emissionReport3.error }}</span>
                            <span>)</span>
                          </template>
                        </div>
                        <div class="emissionReportBrief" style="margin-top: 20px">
                          物料密闭储存与密闭运输 :
                          <br />
                          <span style="margin-left: 40px">巡查通过(</span>
                          <span
                            class="number"
                            :style="{
                              color: emissionReport4.success > 0 ? '#2febff' : '#fff',
                            }"
                          >{{ emissionReport4.success }}</span>
                          <span>)个排放源点位;</span>
                          <template v-if="emissionReport4.error && emissionReport4.error > 0">
                            <br />
                            <span style="margin-left: 40px">问题点位(</span>
                            <span
                              class="number"
                              :style="{
                                color: emissionReport4.error > 0 ? '#f00' : '#fff',
                              }"
                            >{{ emissionReport4.error }}</span>
                            <span>)</span>
                          </template>
                        </div>
                      </div>
                      <div v-else style="font-size: 22px">
                        <div class="emissionReportBrief">
                          生产工艺过程 :
                          <br />
                          <span style="margin-left: 40px">排放源 - 待排查(</span>
                          <span class="number">
                            {{
                            emissionReport1.success + emissionReport1.error
                            }}
                          </span>
                          <span>)个点位</span>
                        </div>
                        <div class="emissionReportBrief" style="margin-top: 20px">
                          物料封闭运输 :
                          <br />
                          <span style="margin-left: 40px">排放源 - 待排查(</span>
                          <span class="number">
                            {{
                            emissionReport2.success + emissionReport2.error
                            }}
                          </span>
                          <span>)个点位</span>
                        </div>
                        <div class="emissionReportBrief" style="margin-top: 20px">
                          物料封闭储存 :
                          <br />
                          <span style="margin-left: 40px">排放源 - 待排查(</span>
                          <span class="number">
                            {{
                            emissionReport3.success + emissionReport3.error
                            }}
                          </span>
                          <span>)个点位</span>
                        </div>
                        <div class="emissionReportBrief" style="margin-top: 20px">
                          物料密闭储存与密闭运输 :
                          <br />
                          <span style="margin-left: 40px">排放源 - 待排查(</span>
                          <span class="number">
                            {{
                            emissionReport4.success + emissionReport4.error
                            }}
                          </span>
                          <span>)个点位</span>
                        </div>
                      </div>
                    </template>
                    <template
                      v-else-if="
                        (!showReport && reportResult && reportResult.length > 0) ||
                        (isSpecial && reportResult && reportResult.length > 0)
                      "
                      v-for="(item, n) in reportResult"
                      v-bind:key="n"
                    >
                      <div class="swiper-slide" v-if="n < 3">
                        <a :style="{ marginTop: n == 0 ? '35px' : '0px' }" href="javascript:void(0)" class="famous_school_item_slide">
                          <div class="popup-type1-idx">{{ n + 1 }}</div>
                          <template v-if="item.inChargeUsers && item.inChargeUsers.length > 0">
                            <div class="warn1_treatmentBox">
                              <template v-bind:key="idx" v-for="(item_, idx) in item.inChargeUsers">
                                <span @click="agoraRTM_call_CN(item_.name)" v-if="idx < 1" class="warn1_treatment">
                                  <img class="person-phone" src="./img/phone-icon.png" />
                                  {{ item_.name }}
                                </span>
                              </template>
                            </div>
                          </template>
                          <template v-else>
                            <div class="warn1_treatmentBox">
                              <span @click="agoraRTM_call_CN('陈雪建')" class="warn1_treatment">
                                <img class="person-phone" src="./img/phone-icon.png" />
                                {{
                                "陈雪建"
                                }}
                              </span>
                            </div>
                          </template>
                          <div class="warn1_title">
                            <div
                              class="popup-type1-title"
                              :class="{
                                'popup-type1-title_green': getWarnType(item.handleState),
                              }"
                            >
                              <template v-if="item.analyzeResult && item.warnType == 5">{{ "道路" }}-{{ "污染识别" }}</template>
                              <template v-else>
                                {{ item.eventName }}
                                <br />
                                {{ item.typeName }}
                              </template>
                            </div>
                            <div class="popup-type2-time">{{ formatTimeVal(item.eventTime) }}</div>
                            <div class="warn1_position" style="font-size: 18px">
                              发生位置:
                              <span>{{ item.deviceName }}</span>
                            </div>
                          </div>
                          <div v-if="false" class="warn1_content">
                            <template v-if="item.warnType == 5">
                              <div class="warn1_road_info">
                                统计时间:
                                <span>
                                  {{ item.analyzeResult.startTime }} ~
                                  {{
                                  item.analyzeResult.endTime
                                  ? item.analyzeResult.endTime.slice(11, 19)
                                  : ""
                                  }}
                                </span>
                              </div>
                              <div class="warn1_road_info">
                                全厂PM10均值:
                                <span>
                                  {{
                                  item.analyzeResult.pm10AvgFactory
                                  ? item.analyzeResult.pm10AvgFactory
                                  : "--"
                                  }}
                                  μg/m³
                                </span>
                              </div>
                              <div class="warn1_road_info">
                                PM10均值:
                                <span>
                                  {{
                                  item.analyzeResult.pm10AvgRoad
                                  ? item.analyzeResult.pm10AvgRoad
                                  : "--"
                                  }}
                                  μg/m³
                                </span>
                              </div>
                              <div class="warn1_road_info" v-if="item.analyzeResult && item.analyzeResult.vdmAvgRoad">
                                VDM均值:
                                <span>{{ item.analyzeResult.vdmAvgRoad }} μg/m³</span>
                              </div>
                            </template>
                            <template v-if="item.warnType != 5">
                              <div class="warn1_box">
                                <div class="smallBox">
                                  <div class="warn1_type_name">{{ item.metric }}</div>
                                  <div class="warn1_type_num">{{ item.value }}</div>
                                  <div class="warn1_type_unit">{{ item.unit }}</div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="agoraStatus" ref="agoraRTC_localVideoBar" class="agoraRTC-localVideoBar"></div>

    <div v-if="agoraStatus" ref="agoraRTC_remoteVideoBar" class="agoraRTC-remoteVideoBar"></div>

    <div class="contact_show_btn" @click="openContact()">
      <img class="contact_show_btn_img" src="./img/contact_show_btn.png" />
    </div>

    <div v-if="agoraStatus && isCalling" class="call_bar">
      <div class="call_bar_bg"></div>
      <div class="call_name">{{ callPerson }}</div>
      <div class="call_icon phoneCall_animate" @click="callDown()">
        <div class="call_txt">呼叫中</div>
      </div>
    </div>

    <a class="cta cta0" @click="dailyRoutePlay()">
      <span v-if="!historyRecordObj.dailyRoute || historyRecordObj.dailyRoute == 'finished'">日常巡查</span>
      <span v-else>日常巡查</span>
    </a>
    <a class="cta0_report" @click="dailyRouteReport()">
      <img src="./img/dailyReport.png" />
    </a>

    <a class="cta cta1" @click="keyPointRoutePlay()">
      <span v-if="
          !historyRecordObj.keyPointRoute || historyRecordObj.keyPointRoute == 'finished'
        ">重点区域巡查</span>
      <span v-else>重点区域巡查</span>
      <!--span>
        <svg
          width="66px"
          height="43px"
          viewBox="0 0 66 43"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="arrow" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path
              class="one"
              d="M40.1543933,3.89485454 L43.9763149,0.139296592 C44.1708311,-0.0518420739 44.4826329,-0.0518571125 44.6771675,0.139262789 L65.6916134,20.7848311 C66.0855801,21.1718824 66.0911863,21.8050225 65.704135,22.1989893 C65.7000188,22.2031791 65.6958657,22.2073326 65.6916762,22.2114492 L44.677098,42.8607841 C44.4825957,43.0519059 44.1708242,43.0519358 43.9762853,42.8608513 L40.1545186,39.1069479 C39.9575152,38.9134427 39.9546793,38.5968729 40.1481845,38.3998695 C40.1502893,38.3977268 40.1524132,38.395603 40.1545562,38.3934985 L56.9937789,21.8567812 C57.1908028,21.6632968 57.193672,21.3467273 57.0001876,21.1497035 C56.9980647,21.1475418 56.9959223,21.1453995 56.9937605,21.1432767 L40.1545208,4.60825197 C39.9574869,4.41477773 39.9546013,4.09820839 40.1480756,3.90117456 C40.1501626,3.89904911 40.1522686,3.89694235 40.1543933,3.89485454 Z"
              fill="#FFFFFF"
            ></path>
            <path
              class="two"
              d="M20.1543933,3.89485454 L23.9763149,0.139296592 C24.1708311,-0.0518420739 24.4826329,-0.0518571125 24.6771675,0.139262789 L45.6916134,20.7848311 C46.0855801,21.1718824 46.0911863,21.8050225 45.704135,22.1989893 C45.7000188,22.2031791 45.6958657,22.2073326 45.6916762,22.2114492 L24.677098,42.8607841 C24.4825957,43.0519059 24.1708242,43.0519358 23.9762853,42.8608513 L20.1545186,39.1069479 C19.9575152,38.9134427 19.9546793,38.5968729 20.1481845,38.3998695 C20.1502893,38.3977268 20.1524132,38.395603 20.1545562,38.3934985 L36.9937789,21.8567812 C37.1908028,21.6632968 37.193672,21.3467273 37.0001876,21.1497035 C36.9980647,21.1475418 36.9959223,21.1453995 36.9937605,21.1432767 L20.1545208,4.60825197 C19.9574869,4.41477773 19.9546013,4.09820839 20.1480756,3.90117456 C20.1501626,3.89904911 20.1522686,3.89694235 20.1543933,3.89485454 Z"
              fill="#FFFFFF"
            ></path>
            <path
              class="three"
              d="M0.154393339,3.89485454 L3.97631488,0.139296592 C4.17083111,-0.0518420739 4.48263286,-0.0518571125 4.67716753,0.139262789 L25.6916134,20.7848311 C26.0855801,21.1718824 26.0911863,21.8050225 25.704135,22.1989893 C25.7000188,22.2031791 25.6958657,22.2073326 25.6916762,22.2114492 L4.67709797,42.8607841 C4.48259567,43.0519059 4.17082418,43.0519358 3.97628526,42.8608513 L0.154518591,39.1069479 C-0.0424848215,38.9134427 -0.0453206733,38.5968729 0.148184538,38.3998695 C0.150289256,38.3977268 0.152413239,38.395603 0.154556228,38.3934985 L16.9937789,21.8567812 C17.1908028,21.6632968 17.193672,21.3467273 17.0001876,21.1497035 C16.9980647,21.1475418 16.9959223,21.1453995 16.9937605,21.1432767 L0.15452076,4.60825197 C-0.0425130651,4.41477773 -0.0453986756,4.09820839 0.148075568,3.90117456 C0.150162624,3.89904911 0.152268631,3.89694235 0.154393339,3.89485454 Z"
              fill="#FFFFFF"
            ></path>
          </g>
        </svg>
      </span-->
    </a>
    <a class="cta1_report" @click="keyPointRouteReport()">
      <img src="./img/keyPointReport.png" />
    </a>

    <a class="cta cta2" @click="customRoutePlay()">
      <span v-if="!historyRecordObj.customRoute || historyRecordObj.customRoute == 'finished'">自定义巡查</span>
      <span v-else>自定义巡查</span>
    </a>
    <a></a>
    <a class="cta2_report" @click="customRouteReport()">
      <img src="./img/customReport.png" />
    </a>

    <span v-show="false" class="endWorkTicket-btn" @click="endWorkTicketHistoryFunc()">结束巡查</span>

    <a class="cta3_report" @click="normalPlay()">
      <img src="./img/endCheck.png" />
    </a>

    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBG == 'typeStrong'"></div>
    <routeSetting @closeRouteSetting="closeRouteSetting" @changeRoute="changeRoute" v-if="routeSettingStatus" :reportType="reportType"></routeSetting>
  </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {
  ExitCruiseFunc,
  CamFixFunc,
  LoadLabelFunc,
  DestroyLabelFunc,
  ParseRoamFunc,
  ContinueRoamFunc,
  Roam2OrbitFunc,
  Orbit2RoamFunc,
  CruiseLeapFunc,
  CruiseLeapBackFunc,
  ShowWallDataFunc,
  CloseWallFunc,
  HideHeatLineFunc,
  ChangeFlySpeedFunc,
  OpenPointsMeshFunc,
  ClosePointsMeshFunc,
  LoadCruiseJsonFunc,
  LoadCruiseNetworkFunc,
  StartCruiseFunc,
  SwitchPauseTriggerFunc,
  ShowMinimapFunc,
  HideMinimapFunc,
  ShowGlobalMapFunc,
  HideGlobalMapFunc,
  SetMapAlphaFunc,
  CancelFixedTimeFunc,
  setDayFunc,
  SetFixedTimeFunc,
  InstantiateEmpTipFunc,
  DestroyEmpTipFunc,
  CamTransBackFunc,
  ShowCarTrailFunc,
  HideCarTrailFunc
} from '@/assets/js/unity3D/index.js'

/*import CryptoJS from "crypto-js";
import Enc from "enc";
import TransWorker from "@/assets/js/transCode/transcode.worker.js";

import toWav from "audiobuffer-to-wav";*/

import warn from '@/modules/AutoVisionMod/warn.vue'

import deviceBar from '@/modules/unorganizedComponents/deviceBar/indexAutoVision.vue'

import routeSetting from './components/routeSetting.vue'

import { ref, shallowRef, computed, provide } from 'vue'

import { mapState, mapGetters } from 'vuex'
import iframePup from '@/modules/iframePup/iframePup.vue'

import { ElMessage } from 'element-plus'

import { getEncryptWithPassword } from '@/utils/cryptoUtil.js';

// import AgoraRTM from "agora-rtm-sdk";
//import AgoraRTC from "agora-rtc-sdk-ng";

const AgoraRTM_appID = '9f0c0ef090024f749a5740297e93b2fb' //"f327a799e9b34ae983e97c939d19c057";
const AgoraRTC_appID = '9f0c0ef090024f749a5740297e93b2fb'
const AgoraRTC_Token = '006594a3658b6ec4f599ce1f795f5551a65IAB++d0iHOKDmilLfbvcdrVOhSCgieGhC2kh5Fytv7m42GFGmVkAAAAAEAANcJk0wSKsYQEAAQDBIqxh'
const AgoraRTM_channelID = bmeConfig.loginName ? bmeConfig.loginName : 'bme_xiaomei' //"bme" + parseInt(Math.random() * 1000);
//http://localhost:9070/screen/agora/tokenByAccount?channelName=bme&userAccount=123456

const agoraRTC_Settings = {
  localAudioTrack: null,
  localVideoTrack: null,
  client: null
}

const agoraRTC_Options = {
  // Pass your App ID here.
  appId: AgoraRTC_appID,
  // Set the channel name.
  channel: AgoraRTM_channelID,
  // Pass your temp token here.
  token: '',
  // Set the user ID.
  uid: 0
}

const dailyRouteAreaIds = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 23, 27, 28, 30, 40, 43, 44]
const keyPointRouteAreaIds = [5, 6, 7, 8, 10, 16, 17, 18, 23]
const customRouteAreaIds = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]

const dailyRouteRoadIds = localStorage['daily_list']
  ? JSON.parse(localStorage['daily_list'])
  : [
      '49',
      '55',
      '60',
      '61',
      '62',
      '65',
      '68',
      '67',
      '66',
      '74',
      '75',
      '78',
      '82',
      '83',
      '90',
      '102',
      '101',
      '111',
      '112',
      '110',
      '98',
      '88',
      '87',
      '80',
      '85',
      '95',
      '84',
      '76',
      '50',
      '43',
      '44'
    ]
const keyPointRouteRoadIds = localStorage['keyPoint_list']
  ? JSON.parse(localStorage['keyPoint_list'])
  : ['60', '61', '62', '65', '71', '75', '74', '66', '59']
const customRouteRoadIds = localStorage['custom_list']
  ? JSON.parse(localStorage['custom_list'])
  : [
      '49',
      '55',
      '60',
      '61',
      '62',
      '65',
      '68',
      '67',
      '66',
      '74',
      '75',
      '78',
      '82',
      '83',
      '90',
      '102',
      '101',
      '111',
      '112',
      '110',
      '98',
      '88',
      '87',
      '80',
      '85',
      '95',
      '84',
      '76',
      '50',
      '43',
      '44'
    ]

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { warn, deviceBar, routeSetting },
  props: {},
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,
      isSetting: false,
      hash: false,
      modelType: 'AutoVision',
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: '',
      refreshTag: true,
      eventData: {},
      curMapType: '',

      factoryDetailShow: false,
      warnDetailShow: false,

      branchFactory: '',
      emissionSourceCount: 0,
      productDeviceCount: 0,
      governmentDeviceCount: 0,
      monitorDeviceCount: 0,
      facotryMonitorDeviceList: {},
      workTicketCount: 0,
      treatmentCount: 0,
      treatmentRate: '0.00%',

      factoryId: '',

      typeId: '',
      warnObj: '',

      playTimer: null,

      factoryTimer: null,

      warnList: [],

      factoryPos: 0,

      factoryReplayTimer: null,

      flyPointStatus: false,

      resultScroll: '',

      description: '',

      hasNext: false,

      resultWarnObj: {},

      resultWarnTypeId: '',

      mircoList: [],

      mircoRepeatCheck: [],

      mircoTimer: null,

      isLoad: false,
      loadStr: '拼命加载中',
      autoHeight: 595,
      sourceData: [],
      warnIdx: '',
      dutyInventoryId: '',
      dutyInventoryName: '',
      deviceStatus: false,

      emissionStatus: false,

      noEquipBuilding: false,

      pastRoadNameObj: {},
      roadName: '经六路',

      showMiniMap: false,
      miniMap: 'big',
      opacityVal: 80,

      slowRate: '4',
      fastRate: '6',
      showFactoryPoint: false,

      unity3DTime: '12:00',

      countInterval: null,
      iatRecorder: null,

      audioContext: null,
      mediaSource: null,
      recorder: null,
      Recorder: null,

      agoraStatus: false,

      agoraRTM_Options: {
        uid: bmeConfig.loginName ? bmeConfig.loginName : 'bme_xiaomei',
        token: ''
      },

      phoneBook: {},
      specialPhoneBook: {},
      specialPhoneBookJson: '',
      phoneBookStatus: {},
      phonePersonIds: [],

      RTMclient: null,
      contactShow: false,
      specialContactShow: false,
      reportShow: false,
      isCalling: false,
      callPerson: '',
      microStatus: false,

      contactType: 'offline',
      contactTypeCN: '全部人员',
      specialContactType: 'nearly',
      specialContactTypeCN: '值班人员',
      onlinePersonStr: '',
      randomPerson: [],
      cleanCars: [],
      //rtm_useId: "cbq_bme",
      //AgoraRTM_channel: "bme",
      reportResult: [],

      reportType: '',
      reportTypeKey: '',
      reportFactoryList: [],
      reportFactoryCNList: [],

      isOrbitVision: false,
      localInvitation: [],

      historyRecordObj: {
        dailyRoute: false,
        keyPointRoute: false,
        customRoute: false
      },
      historyRecordInfoObj: {
        dailyRoute: [],
        keyPointRoute: [],
        customRoute: []
      },
      checkRoute: {
        dailyRoute: [],
        keyPointRoute: [],
        customRoute: []
      },
      checkedRoute: {
        dailyRoute: [],
        keyPointRoute: [],
        customRoute: []
      },
      checkRouteRoads: {
        dailyRoute: [],
        keyPointRoute: [],
        customRoute: []
      },
      checkedRouteRoads: {
        dailyRoute: [],
        keyPointRoute: [],
        customRoute: []
      },
      curCheckRouteType: '',
      autoVisionReportId: '',

      showReport: false,

      routeSettingStatus: false
    }
  },
  computed: {
    countTitle() {
      return function (i) {
        let num = 1
        let date = new Date(i.startTime)
        this.reportHistoryList.map(item => {
          let date1 = new Date(item.startTime)
          if (date.getMonth() == date1.getMonth() && date.getDate() == date1.getDate()) {
            if (date.getTime() > date1.getTime()) {
              num++
            }
          }
        })
        return date.getMonth() + 1 + '月' + date.getDate() + '日第' + num + '次重点区域巡查'
      }
    },
    getWarnType() {
      return function (handleState) {
        let treatType = false
        if (handleState == 0 || handleState == 1) {
          treatType = false
        } else if (handleState == 2) {
          treatType = true
        } else if (handleState == 3) {
          treatType = true
        } else {
          treatType = false
        }
        return treatType
      }
    },
    formatTimeVal() {
      return function (str) {
        let timeStr = new Date(str.replace(/-0/g, '/').replace(/-/g, '/')).Format('MM-dd hh:mm')
        return timeStr
      }
    },
    getHeaderCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return 'thClass_'
        } else {
          return 'thClass'
        }
      }
    },
    getHeadRowClass() {
      return function (obj) {
        return 'headTrClass'
      }
    },
    getCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return 'tdClass_'
        } else {
          return 'tdClass'
        }
      }
    },
    getRowClass() {
      return function (obj) {
        return 'trClass'
      }
    },
    getContainerBG: function () {
      let imgSrc = ''
      if (this.curBG && this.styleTypeMap[this.curBG] && this.styleTypeMap[this.curBG].dutyBG) {
        imgSrc = require('@/views/MainMod/img/' + this.styleTypeMap[this.curBG].dutyBG)
      }
      return imgSrc
    },
    getContainerBG_: function () {
      let imgSrc = ''
      if (this.curBG && this.styleTypeMap[this.curBG] && this.styleTypeMap[this.curBG].dutyBG) {
        imgSrc = require('@/views/AutoVisionMod/img/bg.png')
      }
      return imgSrc
    },
    curBGVal: function () {
      return this.$store.state.curBG
    },
    mapTypeVal() {
      return this.$store.state.mapType
    },
    ...mapGetters({
      dialogCompontent: 'getDialogCompontent'
    })
  },
  //监控data中的数据变化
  watch: {
    reportTypeKey: {
      handler(newVal, oldVal) {
        this.$store.commit('reportTypeKey', newVal)
      },
      deep: true
    },
    contactType: {
      handler(newVal, oldVal) {
        if (newVal == 'online') {
          this.contactTypeCN = '在线人员'
        } else if (newVal == 'offline') {
          this.contactTypeCN = '全部人员'
        }
      },
      deep: true
    },
    specialContactType: {
      handler(newVal, oldVal) {
        if (newVal == 'nearly') {
          this.specialContactTypeCN = '值班人员'
        } else if (newVal == 'car') {
          this.specialContactTypeCN = '值班司机'
        }
      },
      deep: true
    },
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal
      },
      deep: true
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal
      },
      deep: true
    },
    mapTypeVal: {
      handler(newVal, oldVal) {
        this.curMapType = newVal
      },
      deep: true
    },
    '$store.state.emissionSwitch': {
      handler(val, oldVal) {
        if (val && val.indexOf('openReport') >= 0) {
          this.openReport = true
        } else if (val != 'open') {
          this.openReport = false
          this.$forceUpdate()
        }
      }
    }
  },
  provide: function () {
    return {
      getDutyInventoryId: computed(() => this.dutyInventoryId),
      updateDutyInventoryId: this.updateDutyInventoryId
    }
  },
  //方法集合
  methods: {
    openRouteSetting() {
      this.routeSettingStatus = true
    },
    closeRouteSetting() {
      this.routeSettingStatus = false
    },
    changeRoute(data) {
      console.log(localStorage[data + '_list'])
      if (localStorage[data + '_list']) {
        if (data == 'daily') {
          dailyRouteRoadIds = JSON.parse(localStorage[data + '_list'])
        } else if (data == 'keyPoint') {
          keyPointRouteRoadIds = JSON.parse(localStorage[data + '_list'])
        } else if (data == 'custom') {
          customRouteRoadIds = JSON.parse(localStorage[data + '_list'])
        }
      }
    },
    switchReport(valid) {
      if (valid) {
        this.showReport = false
      } else {
        this.showReport = true
      }
    },
    calcRoute(roadId) {
      if (this.curCheckRouteType) {
        if ($.inArray(roadId, this.checkedRouteRoads[this.curCheckRouteType]) < 0) {
          this.checkedRouteRoads[this.curCheckRouteType].push(roadId)
        }
      }
    },
    calcFactory(factoryId) {
      if (this.curCheckRouteType) {
        if ($.inArray(factoryId, this.checkedRoute[this.curCheckRouteType]) < 0) {
          this.checkedRoute[this.curCheckRouteType].push(factoryId)
        }
      }
    },
    clearRouteChecked(alarmType) {
      if (alarmType) {
        this.checkedRoute['alarmType'] = []
      } else {
        this.checkedRoute = {
          dailyRoute: [],
          keyPointRoute: [],
          customRoute: []
        }
      }
    },
    clearFactoryChecked(alarmType) {
      if (alarmType) {
        this.checkedRouteRoads['alarmType'] = []
      } else {
        this.checkedRouteRoads = {
          dailyRoute: [],
          keyPointRoute: [],
          customRoute: []
        }
      }
    },
    fetchLastRoad(alarmType) {
      let result = ''
      if (alarmType && this.checkedRouteRoads[alarmType] && this.checkedRouteRoads[alarmType].length > 0) {
        result = this.checkedRouteRoads[this.checkedRouteRoads[alarmType].length]
      } else {
        if (alarmType == 'dailyRoute') {
          this.checkRouteRoads[alarmType] = dailyRouteRoadIds
        } else if (alarmType == 'keyPointRoute') {
          this.checkRouteRoads[alarmType] = keyPointRouteRoadIds
        } else if (alarmType == 'customRoute') {
          this.checkRouteRoads[alarmType] = customRouteRoadIds
        }

        result = this.checkRouteRoads[alarmType][0]
      }
      return result
    },
    async addWorkTicketHistoryFunc(areaIds, alarmType) {
      let addWorkTicketHistoryUrl = CONFIG.requestName + this.$apiOpt.addWorkTicketHistory
      let result = await this.$apiUtils.get(addWorkTicketHistoryUrl, {
        customerId: this.customerId,
        areaIds: areaIds,
        alarmType: alarmType
      })
      this.findWorkTicketHistoryFunc()
      return result
    },
    async endWorkTicketHistoryFunc(isAllAreaCheck) {
      let areaIds = this.checkedRoute[this.curCheckRouteType]
      let idx = this.historyRecordObj[this.curCheckRouteType]
      if (isAllAreaCheck && idx) {
        if (this.curCheckRouteType == 'dailyRoute') {
          areaIds = dailyRouteAreaIds
        } else if (this.curCheckRouteType == 'keyPointRoute') {
          areaIds = keyPointRouteAreaIds
        } else if (this.curCheckRouteType == 'customRoute') {
          areaIds = customRouteAreaIds
        }
        if (areaIds && idx && idx != 'finished') {
          await this.updateWorkTicketHistoryFunc(areaIds.join(','), idx)
          this.clearRouteChecked()
          this.clearFactoryChecked()
        }
      } else {
        if (areaIds && idx && idx != 'finished') {
          await this.updateWorkTicketHistoryFunc(areaIds.join(','), idx)
          this.clearRouteChecked()
          this.clearFactoryChecked()
        }
      }

      //this.checkedRoute();
      //this.normalPlay();
    },
    async updateWorkTicketHistoryFunc(areaIds, idx) {
      let updateWorkTicketHistoryUrl = CONFIG.requestName + this.$apiOpt.updateWorkTicketHistory
      let result = await this.$apiUtils.get(updateWorkTicketHistoryUrl, {
        customerId: this.customerId,
        areaIds: areaIds,
        indexVal: idx
      })
      this.reportListShow = false
      await this.findWorkTicketHistoryFunc()
      return result
    },
    async findWorkTicketEmissionFunc(idx, emissionSourceType) {
      let findWorkTicketEmissionUrl = CONFIG.requestName + this.$apiOpt.findWorkTicketEmission
      let result = await this.$apiUtils.get(findWorkTicketEmissionUrl, {
        id: idx,
        emissionSourceType: emissionSourceType
      })
      return result
    },
    async findWorkTicketHistoryFunc() {
      //获取历史巡查报告记录
      let curDateObj = new Date()
      let curDateFormat = curDateObj.Format('yyyy-MM-dd hh:mm:ss')
      let findWorkTicketHistoryUrl = CONFIG.requestName + this.$apiOpt.findWorkTicketHistory
      let resultReport = await this.$apiUtils.get(findWorkTicketHistoryUrl, {
        customerId: this.customerId,
        startTime: '',
        endTime: ''
      })

      resultReport.sort((a, b) => {
        /*let aTs = a["endTime"]
          ? new Date(a["endTime"].replace(/-0/g, "/").replace(/-/g, "/")).getTime()
          : new Date().getTime();
        let bTs = b["endTime"]
          ? new Date(b["endTime"].replace(/-0/g, "/").replace(/-/g, "/")).getTime()
          : new Date().getTime();*/
        let aTs = a['startTime'] ? new Date(a['startTime'].replace(/-0/g, '/').replace(/-/g, '/')).getTime() : new Date().getTime()
        let bTs = b['startTime'] ? new Date(b['startTime'].replace(/-0/g, '/').replace(/-/g, '/')).getTime() : new Date().getTime()
        return bTs - aTs
      })
      console.log(resultReport)
      this.historyRecordObj = {
        dailyRoute: false,
        keyPointRoute: false,
        customRoute: false
      }
      this.historyRecordInfoObj = {
        dailyRoute: [],
        keyPointRoute: [],
        customRoute: []
      }
      resultReport.forEach(item => {
        if (item.alarmType == '日常巡查') {
          if (!this.historyRecordObj.dailyRoute) {
            if (item.endTime) {
              this.historyRecordObj.dailyRoute = 'finished'
              this.clearRouteChecked('dailyRoute')
              this.clearFactoryChecked('dailyRoute')
            } else {
              this.historyRecordObj.dailyRoute = item.indexVal
            }
          }
          this.historyRecordInfoObj.dailyRoute.push(item)
        } else if (item.alarmType == '重点区域巡查') {
          if (!this.historyRecordObj.keyPointRoute) {
            if (item.endTime) {
              this.historyRecordObj.keyPointRoute = 'finished'
              this.clearRouteChecked('keyPointRoute')
              this.clearFactoryChecked('keyPointRoute')
            } else {
              this.historyRecordObj.keyPointRoute = item.indexVal
            }
          }
          this.historyRecordInfoObj.keyPointRoute.push(item)
        } else if (item.alarmType == '自定义巡查') {
          if (!this.historyRecordObj.customRoute) {
            if (item.endTime) {
              this.historyRecordObj.customRoute = 'finished'
              this.clearRouteChecked('customRoute')
              this.clearFactoryChecked('customRoute')
            } else {
              this.historyRecordObj.customRoute = item.indexVal
            }
            this.historyRecordInfoObj.customRoute.push(item)
          }
        }
      })
      console.log(this.historyRecordObj)
      this.$forceUpdate()
    },
    switchAutoVision() {
      if (this.autoVisionSwitchTimer) {
        clearTimeout(this.autoVisionSwitchTimer)
      }
      this.autoVisionSwitchTimer = setTimeout(() => {
        if (!this.isOrbitVision) {
          this.isOrbitVision = true
          window.isOrbitVision = true
          ParseRoamFunc(true)
        } else {
          this.isOrbitVision = false
          window.isOrbitVision = false
          ContinueRoamFunc()
        }
      }, 500)
    },
    getRemoteContactWin() {
      let num = 0
      if (
        this.$refs.agoraRTC_remoteVideoBar &&
        $(this.$refs.agoraRTC_remoteVideoBar) &&
        $(this.$refs.agoraRTC_remoteVideoBar).children() &&
        $(this.$refs.agoraRTC_remoteVideoBar).children().length
      ) {
        num = $(this.$refs.agoraRTC_remoteVideoBar).children().length
      }
      return num
    },
    customReadMore() {
      this.reportDetail = true
      this.$forceUpdate()
      this.$nextTick(() => {
        let options = {
          speed: 5000, //匀速时间
          direction: 'vertical',
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          loop: this.reportResult.length > 4 ? true : false,
          loopedSlides: 4,
          slidesPerView: 4,
          spaceBetween: 15,
          observer: true,
          observeParents: true // 当Swiper的父元素变化时，会更新swiper
        }

        $.extend({
          swiperOption1: function (f1, f2) {
            let swiper = new Swiper(f1, f2)
            return swiper
          }
        })

        if (this.swiper1 && this.swiper1.autoplay) {
          this.swiper1.autoplay.stop()
        }

        this.swiper1 = $.swiperOption1($(this.$refs.definedRouterReportDetail).eq(0).find('.swiper-container'), options)
      })
    },
    moreEmissionReport(titleName) {
      if (this.autoVisionReportId) {
        let warnType = this.curCheckRouteType
        let startTime = '',
          endTime = '',
          areaIds = ''

        let curHistoryRecordInfoObj = this.curHistoryRecordInfoObj
        if (curHistoryRecordInfoObj) {
          startTime = curHistoryRecordInfoObj['startTime']
          endTime = curHistoryRecordInfoObj['endTime']
          areaIds = curHistoryRecordInfoObj['areaIds']
        }
        this.$store.commit(
          'changeEmissionSwitch',
          'openReport@=' + this.autoVisionReportId + '@=' + startTime + '@=' + endTime + '@=' + areaIds + '@=' + titleName
        )
      }
    },
    closeReport() {
      if (this.swiper0 && this.swiper0.autoplay) {
        this.swiper0.autoplay.stop()
      }
      if (this.swiper1 && this.swiper1.autoplay) {
        this.swiper1.autoplay.stop()
      }
      if (this.swiper2 && this.swiper2.autoplay) {
        this.swiper2.autoplay.stop()
      }

      if (ContinueRoamFunc) {
        ContinueRoamFunc()
      }

      this.reportListShow = false
      this.$forceUpdate()
    },
    customBrief(idx) {
      this.reportDetail = false
      if (idx) {
        this.autoVisionReportId = idx
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        let options = {
          speed: 2000, //匀速时间
          direction: 'vertical',
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          loop: false,
          loopedSlides: 4,
          slidesPerView: 4,
          spaceBetween: 5,
          observer: true,
          observeParents: true // 当Swiper的父元素变化时，会更新swiper
        }

        $.extend({
          swiperOption: function (f1, f2) {
            let swiper = new Swiper(f1, f2)
            return swiper
          }
        })

        if (this.swiper0 && this.swiper0.autoplay) {
          this.swiper0.autoplay.stop()
        }

        this.swiper0 = $.swiperOption($(this.$refs.definedRouterReport).eq(0).find('.swiper-container'), options)
        this.swiper0.autoplay.stop()
      })
    },
    async customRoutePlay() {
      await this.endWorkTicketHistoryFunc(true)
      let beginRoadId = '74' //roadList[Math.floor(Math.random() * roadList.length)];
      if (!this.historyRecordObj.customRoute || this.historyRecordObj.customRoute == 'finished') {
        this.checkRoute.customRoute = customRouteAreaIds
        this.checkRouteRoads.customRoute = customRouteRoadIds
        this.checkedRoute.customRoute = []
        this.checkedRouteRoads.customRoute = []
        let addResult = await this.addWorkTicketHistoryFunc(customRouteAreaIds.join(','), '自定义巡查')
        this.historyRecordObj.customRoute = addResult
        console.log(addResult)
      } else {
        beginRoadId = this.fetchLastRoad('customRoute')
      }
      this.curCheckRouteType = 'customRoute'
      this.dailyRoutePlaying = false
      this.keyPointRoutePlaying = false
      this.customRoutePlaying = true
      this.isOrbitVision = false
      window.isOrbitVision = false
      this.reportTypeKey = 'custom'
      this.reportListShow = false
      bmeConfig.pastRoadList = {}
      let roadList = customRouteRoadIds
      roadList.forEach(item => {
        bmeConfig.pastRoadList[item] = -9999
      })
      //结束巡航
      if (ExitCruiseFunc) {
        ExitCruiseFunc()
      }

      setTimeout(() => {
        LoadCruiseJsonFunc()
        setTimeout(() => {
          LoadCruiseNetworkFunc()
          setTimeout(() => {
            let cruiseJsonObj = {
              name: beginRoadId,
              head: 'true'
            }
            window.cruiseJson = JSON.stringify(cruiseJsonObj)
            StartCruiseFunc()
            setTimeout(() => {
              SwitchPauseTriggerFunc('false')
              this.roadName = bmeConfig.pastRoadNameList[beginRoadId] ? bmeConfig.pastRoadNameList[beginRoadId] : '未命名道路'
            }, 50)
          }, 50)
        }, 50)
      }, 1000)
    },
    async keyPointRoutePlay() {
      await this.endWorkTicketHistoryFunc(true)
      let beginRoadId = '60'
      if (!this.historyRecordObj.keyPointRoute || this.historyRecordObj.keyPointRoute == 'finished') {
        this.checkRoute.keyPointRoute = keyPointRouteAreaIds
        this.checkRouteRoads.keyPointRoute = keyPointRouteRoadIds
        this.checkedRoute.keyPointRoute = []
        this.checkedRouteRoads.keyPointRoute = []
        let addResult = await this.addWorkTicketHistoryFunc(keyPointRouteAreaIds.join(','), '重点区域巡查')
        this.historyRecordObj.keyPointRoute = addResult
        console.log(addResult)
      } else {
        beginRoadId = this.fetchLastRoad('keyPointRoute')
      }
      this.curCheckRouteType = 'keyPointRoute'
      this.dailyRoutePlaying = false
      this.keyPointRoutePlaying = true
      this.customRoutePlaying = false
      this.isOrbitVision = false
      window.isOrbitVision = false
      this.reportTypeKey = 'keyPoint'
      this.reportListShow = false
      bmeConfig.pastRoadList = {}
      let roadList = keyPointRouteRoadIds
      roadList.forEach(item => {
        bmeConfig.pastRoadList[item] = -9999
      })
      //结束巡航
      if (ExitCruiseFunc) {
        ExitCruiseFunc()
      }

      setTimeout(() => {
        LoadCruiseJsonFunc()
        setTimeout(() => {
          LoadCruiseNetworkFunc()
          setTimeout(() => {
            let cruiseJsonObj = {
              name: beginRoadId,
              head: 'true'
            }
            window.cruiseJson = JSON.stringify(cruiseJsonObj)
            StartCruiseFunc()
            setTimeout(() => {
              SwitchPauseTriggerFunc('false')
              this.roadName = bmeConfig.pastRoadNameList[beginRoadId] ? bmeConfig.pastRoadNameList[beginRoadId] : '未命名道路'
            }, 50)
          }, 50)
        }, 50)
      }, 1000)
    },
    async dailyRoutePlay() {
      await this.endWorkTicketHistoryFunc(true)
      let beginRoadId = '60'
      if (!this.historyRecordObj.dailyRoute || this.historyRecordObj.dailyRoute == 'finished') {
        this.checkRoute.dailyRoute = dailyRouteAreaIds
        this.checkRouteRoads.dailyRoute = dailyRouteRoadIds
        this.checkedRoute.dailyRoute = []
        this.checkedRouteRoads.dailyRoute = []
        let addResult = await this.addWorkTicketHistoryFunc(dailyRouteAreaIds.join(','), '日常巡查')
        this.historyRecordObj.dailyRoute = addResult
        console.log(addResult)
      } else {
        beginRoadId = this.fetchLastRoad('dailyRoute')
      }
      this.curCheckRouteType = 'dailyRoute'
      this.dailyRoutePlaying = true
      this.keyPointRoutePlaying = false
      this.customRoutePlaying = false
      this.isOrbitVision = false
      window.isOrbitVision = false
      this.reportTypeKey = 'daily'
      this.reportListShow = false
      bmeConfig.pastRoadList = {}
      let roadList = dailyRouteRoadIds
      roadList.forEach(item => {
        bmeConfig.pastRoadList[item] = -9999
      })
      //结束巡航
      if (ExitCruiseFunc) {
        ExitCruiseFunc()
      }

      setTimeout(() => {
        LoadCruiseJsonFunc()
        setTimeout(() => {
          LoadCruiseNetworkFunc()
          setTimeout(() => {
            let cruiseJsonObj = {
              name: beginRoadId,
              head: 'true'
            }
            window.cruiseJson = JSON.stringify(cruiseJsonObj)
            StartCruiseFunc()
            setTimeout(() => {
              SwitchPauseTriggerFunc('false')
              this.roadName = bmeConfig.pastRoadNameList[beginRoadId] ? bmeConfig.pastRoadNameList[beginRoadId] : '未命名道路'
            }, 50)
          }, 50)
        }, 50)
      }, 1000)
    },
    async normalPlay() {
      await this.endWorkTicketHistoryFunc()
      this.dailyRoutePlaying = false
      this.keyPointRoutePlaying = false
      this.customRoutePlaying = false
      this.isOrbitVision = false
      window.isOrbitVision = false
      this.reportTypeKey = 'auto'
      this.reportListShow = false
      bmeConfig.pastRoadList = {}
      let roadList = [
        '49',
        '55',
        '60',
        '61',
        '62',
        '65',
        '68',
        '67',
        '66',
        '74',
        '75',
        '78',
        '82',
        '83',
        '90',
        '102',
        '101',
        '111',
        '112',
        '110',
        '98',
        '88',
        '87',
        '80',
        '85',
        '95',
        '84',
        '76',
        '50',
        '43',
        '44'
      ]
      roadList.forEach(item => {
        bmeConfig.pastRoadList[item] = -9999
      })
      let beginRoadId = roadList[Math.floor(Math.random() * roadList.length)]
      let pastRoadNameList = bmeConfig.pastRoadNameList
      let pastRoadNameObj = {}
      for (let i in pastRoadNameList) {
        let keyWord = pastRoadNameList[i]
        if ($.isEmptyObject(pastRoadNameObj[keyWord])) {
          pastRoadNameObj[keyWord] = []
        }
        pastRoadNameObj[keyWord].push(i)
      }
      let roadName = ''
      for (let i in pastRoadNameObj) {
        if (!i) {
          continue
        }
        if (beginRoadId.indexOf(i) >= 0) {
          roadName = i
          break
        }
      }
      //结束巡航
      if (ExitCruiseFunc) {
        ExitCruiseFunc()
      }

      setTimeout(() => {
        LoadCruiseJsonFunc()
        setTimeout(() => {
          LoadCruiseNetworkFunc()
          setTimeout(() => {
            let cruiseJsonObj = {
              name: beginRoadId,
              head: 'true'
            }
            window.cruiseJson = JSON.stringify(cruiseJsonObj)
            StartCruiseFunc()
            setTimeout(() => {
              SwitchPauseTriggerFunc('false')
              this.roadName = roadName
            }, 50)
          }, 50)
        }, 50)
      }, 50)
    },
    leaveKeyRoute() {
      if (this.curCheckRouteType == 'dailyRoute') {
      } else if (this.curCheckRouteType == 'keyPointRoute') {
      } else if (this.curCheckRouteType == 'customRoute') {
      }
    },
    dailyRouteReport(id, name, idx) {
      this.reportListShow = true
      this.reportType = '日常巡查'
      this.reportFactoryStr = name ? name : '块矿料棚, 钢渣处理, 白灰车间'
      this.$forceUpdate()
      let areaIds = dailyRouteAreaIds
      if (id) {
        areaIds = [id]
      } else {
        if (ParseRoamFunc) {
          ParseRoamFunc()
        }
      }
      if (!idx) {
        this.reportFactoryList = areaIds
        this.reportAddressDetail = false
        this.reportFactoryCNList = []
        for (let i = 0; i < this.allFactoryList.length; i++) {
          let item = this.allFactoryList[i]
          if ($.inArray(item.id, areaIds) >= 0) {
            this.reportFactoryCNList.push(item.name)
          }
        }
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        if (id) {
          this.getWorkTicketReport(areaIds, id)
        } else {
          this.getWorkTicketReportNew('dailyRoute', idx)
        }
      })
    },
    customRouteReport(id, name, idx) {
      this.reportListShow = true
      this.reportType = '自定义巡查'
      this.reportFactoryStr = name ? name : '850扎线、能管中心、烧结配料'
      this.$forceUpdate()
      let areaIds = customRouteAreaIds
      if (id) {
        areaIds = [id]
      } else {
        if (ParseRoamFunc) {
          ParseRoamFunc()
        }
      }
      if (!idx) {
        this.reportFactoryList = areaIds
        this.reportAddressDetail = false
        this.reportFactoryCNList = []
        for (let i = 0; i < this.allFactoryList.length; i++) {
          let item = this.allFactoryList[i]
          if ($.inArray(item.id, areaIds) >= 0) {
            this.reportFactoryCNList.push(item.name)
          }
        }
      }

      this.$forceUpdate()
      this.$nextTick(() => {
        if (id) {
          this.getWorkTicketReport(areaIds, id)
        } else {
          this.getWorkTicketReportNew('customRoute', idx)
        }
      })
    },
    keyPointRouteReport(id, name, idx) {
      this.reportListShow = true
      this.reportType = '重点区域巡查'
      this.reportFactoryStr = name ? name : '2号高炉、3号高炉、4号高炉'
      this.$forceUpdate()
      let areaIds = keyPointRouteAreaIds
      if (id) {
        areaIds = [id]
      } else {
        if (ParseRoamFunc) {
          ParseRoamFunc()
        }
      }
      if (!idx) {
        this.reportFactoryList = areaIds
        this.reportAddressDetail = false
        this.reportFactoryCNList = []
        for (let i = 0; i < this.allFactoryList.length; i++) {
          let item = this.allFactoryList[i]
          if ($.inArray(item.id, areaIds) >= 0) {
            this.reportFactoryCNList.push(item.name)
          }
        }
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        if (id) {
          this.getWorkTicketReport(areaIds, id)
        } else {
          this.getWorkTicketReportNew('keyPointRoute', idx)
        }
      })
    },
    async getWorkTicketReportNew(type, id, isSpecial) {
      let warnType = type ? type : this.curCheckRouteType
      let idx = ''
      let startTime = ''
      let status = false
      let areaIds = ''
      if (!id) {
        if (this.historyRecordInfoObj[warnType] && this.historyRecordInfoObj[warnType].length > 0) {
          this.curHistoryRecordInfoObj = this.historyRecordInfoObj[warnType][0]
          idx = this.historyRecordInfoObj[warnType][0]['id']
          if (idx) {
            this.autoVisionReportId = idx
          }
          startTime = this.historyRecordInfoObj[warnType][0]['startTime']
          let areaIdStr = this.historyRecordInfoObj[warnType][0]['areaIds']
          areaIds = areaIdStr.split(',')
          this.reportSearchTime = startTime
        }
        if (!this.historyRecordObj[warnType] || this.historyRecordObj[warnType] == 'finished') {
          this.reportSearchStatus = true
        } else {
          this.reportSearchStatus = false
        }
      } else {
        if (this.historyRecordInfoObj[warnType] && this.historyRecordInfoObj[warnType].length > 0) {
          this.historyRecordInfoObj[warnType].forEach((item, n) => {
            if (item.indexVal == id) {
              this.curHistoryRecordInfoObj = this.historyRecordInfoObj[warnType][n]
              idx = this.historyRecordInfoObj[warnType][n]['id']
              startTime = this.historyRecordInfoObj[warnType][n]['startTime']
              let endTime = this.historyRecordInfoObj[warnType][n]['endTime']
              let areaIdStr = this.historyRecordInfoObj[warnType][n]['areaIds']
              areaIds = areaIdStr.split(',')
              if (endTime) {
                this.reportSearchStatus = true
              } else {
                this.reportSearchStatus = false
              }
              this.reportSearchTime = startTime
            }
          })
        }
      }

      this.reportFactoryList = areaIds
      this.reportFactoryCNList = []
      let tempList = []
      for (let i = 0; i < this.allFactoryList.length; i++) {
        let item = this.allFactoryList[i]
        if ($.inArray(item.id + '', areaIds) >= 0) {
          this.reportFactoryCNList.push(item.name)
          if (tempList.length < 3) {
            tempList.push(item.name)
          }
        }
      }

      this.reportFactoryStr = tempList.join(',')

      console.log(this.reportFactoryList)
      console.log(this.reportFactoryCNList)
      console.log(idx)
      if (idx) {
        let findWorkTicketUrl = CONFIG.requestName + this.$apiOpt.findWorkTicket
        let resultReport = await this.$apiUtils.get(findWorkTicketUrl, {
          id: idx
        })
        console.log(resultReport)
        if (resultReport && resultReport.list && resultReport.list.length > 0) {
          this.reportResult = resultReport.list
        } else {
          this.reportResult = []
        }
        this.$forceUpdate()
      } else {
        this.reportResult = []
        this.$forceUpdate()
      }

      let findWorkTicketEmissionUrl = CONFIG.requestName + this.$apiOpt.findWorkTicketEmission
      let emissionReport1 = await this.$apiUtils.get(findWorkTicketEmissionUrl, {
        id: idx,
        emissionSourceType: '生产工艺过程'
      })
      let emissionReport2 = await this.$apiUtils.get(findWorkTicketEmissionUrl, {
        id: idx,
        emissionSourceType: '物料封闭运输'
      })
      let emissionReport3 = await this.$apiUtils.get(findWorkTicketEmissionUrl, {
        id: idx,
        emissionSourceType: '物料封闭储存'
      })
      let emissionReport4 = await this.$apiUtils.get(findWorkTicketEmissionUrl, {
        id: idx,
        emissionSourceType: '物料密闭储存与密闭运输'
      })
      this.emissionReport1 = { success: 0, error: 0 }
      emissionReport1.forEach(item => {
        if (item.type) {
          this.emissionReport1.success++
        } else {
          this.emissionReport1.error++
        }
      })
      this.emissionReport2 = { success: 0, error: 0 }
      emissionReport2.forEach(item => {
        if (item.type) {
          this.emissionReport2.success++
        } else {
          this.emissionReport2.error++
        }
      })
      this.emissionReport3 = { success: 0, error: 0 }
      emissionReport3.forEach(item => {
        if (item.type) {
          this.emissionReport3.success++
        } else {
          this.emissionReport3.error++
        }
      })
      this.emissionReport4 = { success: 0, error: 0 }
      emissionReport4.forEach(item => {
        if (item.type) {
          this.emissionReport4.success++
        } else {
          this.emissionReport4.error++
        }
      })

      if (isSpecial) {
        this.isSpecial = true
      } else {
        this.isSpecial = false
      }

      this.$nextTick(() => {
        if (this.reportShow) {
          $(this.$refs.reportBar).EasySlides({
            autoplay: true,
            show: 6
          })
        }

        if (this.reportListShow) {
          let tmpAreaIds = []
          if (warnType == 'dailyRoute') {
            tmpAreaIds = dailyRouteAreaIds
          } else if (warnType == 'keyPointRoute') {
            tmpAreaIds = keyPointRouteAreaIds
          } else if (warnType == 'customRoute') {
            tmpAreaIds = customRouteAreaIds
          }
          if (!id) {
            this.customAddressBriefNew(this.historyRecordInfoObj[warnType], tmpAreaIds)
          }
          this.customBrief(idx)
        }

        if (isSpecial) {
          $('.reportList').addClass('specialReport')
        } else {
          $('.reportList').removeClass('specialReport')
        }
        //$(".reportList").addClass("specialReport");
      })
    },
    async getWorkTicketReport(areaIds, isSpecial) {
      let warnType = this.curCheckRouteType
      let idx = ''
      let startTime = ''
      /*let startTime = new Date(new Date().getTime() - 60 * 60 * 24 * 1000).Format(
        "yyyy-MM-dd hh:mm:ss"
      );
      this.reportSearchTime = startTime;*/
      let endTime = new Date().Format('yyyy-MM-dd hh:mm:ss')
      if (this.historyRecordInfoObj[warnType] && this.historyRecordInfoObj[warnType].length > 0) {
        idx = this.historyRecordInfoObj[warnType][0]['id']
        if (idx) {
          this.autoVisionReportId = idx
        }
        startTime = this.historyRecordInfoObj[warnType][0]['startTime']
        //let areaIdStr = areaIds.join(",");
        //areaIds = areaIdStr.split(",");
        this.reportSearchTime = startTime
      }
      if (!this.historyRecordObj[warnType] || this.historyRecordObj[warnType] == 'finished') {
        this.reportSearchStatus = false
      } else {
        this.reportSearchStatus = false
      }

      this.reportFactoryList = areaIds
      this.reportFactoryCNList = []
      let tempList = []
      for (let i = 0; i < this.allFactoryList.length; i++) {
        let item = this.allFactoryList[i]
        if ($.inArray(item.id + '', areaIds) >= 0) {
          this.reportFactoryCNList.push(item.name)
          if (tempList.length < 3) {
            tempList.push(item.name)
          }
        }
      }

      this.reportFactoryStr = tempList.join(',')

      let getWorkTicketReportUrl = CONFIG.requestName + this.$apiOpt.workTicketReport
      let resultReport = await this.$apiUtils.get(getWorkTicketReportUrl, {
        customerId: this.customerId,
        startTime: startTime,
        endTime: endTime,
        areaIds: areaIds.join(','),
        pageIndex: 1,
        pageSize: 100
      })
      console.log(resultReport)

      if (resultReport && resultReport.list && resultReport.list.length > 0) {
        this.reportResult = resultReport.list
      } else {
        this.reportResult = []
      }

      if (isSpecial) {
        this.isSpecial = true
      } else {
        this.isSpecial = false
      }
      this.$forceUpdate()
      this.$nextTick(() => {
        if (this.reportShow) {
          $(this.$refs.reportBar).EasySlides({
            autoplay: true,
            show: 6
          })
        }

        if (this.reportListShow) {
          //this.customAddressBrief();
          this.reportAddressDetail = true
          this.customBrief()
        }

        if (isSpecial) {
          $('.reportList').addClass('specialReport')
        } else {
          $('.reportList').removeClass('specialReport')
        }
        //$(".reportList").addClass("specialReport");
      })
    },
    customAddressBriefNew(list, areaIds) {
      list.forEach(item => {
        item.totalAreasNum = areaIds.length
        item.checkNum = item.areaIds.split(',').length
      })
      this.reportHistoryList = list
      this.reportAddressDetail = true
      this.$forceUpdate()
      this.$nextTick(() => {
        /*let options = {
          speed: 2000, //匀速时间
          direction: "vertical",
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop: list.length > 4 ? true : false,
          loopedSlides: list.length * 2,
          slidesPerView: "auto",
          observer: true,
          observeParents: true, // 当Swiper的父元素变化时，会更新swiper
        };

        $.extend({
          swiperOption2: function (f1, f2) {
            let swiper = new Swiper(f1, f2);
            return swiper;
          },
        });

        if (this.swiper2 && this.swiper2.autoplay) {
          this.swiper2.autoplay.stop();
        }

        this.swiper2 = $.swiperOption2(
          $(this.$refs.addressRouterReportDetail).eq(0).find(".swiper-container"),
          options
        );*/
      })
    },
    customAddressBrief() {
      this.reportAddressDetail = true
      this.$forceUpdate()
      this.$nextTick(() => {
        let options = {
          speed: 8000, //匀速时间
          direction: 'vertical',
          autoplay: {
            delay: 50,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          loop: this.reportFactoryCNList.length > 7 ? true : false,
          loopedSlides: 7,
          slidesPerView: 9,
          spaceBetween: 15,
          observer: true,
          observeParents: true // 当Swiper的父元素变化时，会更新swiper
        }

        $.extend({
          swiperOption2: function (f1, f2) {
            let swiper = new Swiper(f1, f2)
            return swiper
          }
        })

        if (this.swiper2 && this.swiper2.autoplay) {
          this.swiper2.autoplay.stop()
        }

        this.swiper2 = $.swiperOption2($(this.$refs.addressRouterReportDetail).eq(0).find('.swiper-container'), options)
      })
    },
    searchReportDetial(idx, list, id) {
      let name = ''
      let nameList = []
      let newList = list.split(',')
      newList.forEach(item => {
        this.allFactoryList.forEach(item_ => {
          if (item == item_.id) {
            if (nameList.length < 3) {
              nameList.push(item.name)
            }
          }
        })
      })
      name = nameList.join(',')
      if (this.reportType == '日常巡查') {
        this.dailyRouteReport('', name, idx)
      } else if (this.reportType == '重点区域巡查') {
        this.keyPointRouteReport('', name, idx)
      } else if (this.reportType == '自定义巡查') {
        this.customRouteReport('', name, idx)
      }
      if (id) {
        this.autoVisionReportId = id
      }
    },
    nearlyPerson() {
      this.specialContactShow = true
      //this.specialContactShow = false;
      this.specialContactType = 'nearly'
      this.initSpecialContactData()
    },
    nearlyCar() {
      //this.contactShow = false;
      this.specialContactShow = true
      this.specialContactType = 'car'
      this.initSpecialContactData()
    },
    switchContact() {
      this.contactShow = true
      if (this.contactType == 'offline') {
        this.contactType = 'online'
      } else {
        this.contactType = 'offline'
      }
      this.initContactData()
    },
    switchSpecialContact() {
      this.specialContactShow = true
      if (this.specialContactType == 'nearly') {
        this.specialContactType = 'car'
      } else {
        this.specialContactType = 'nearly'
      }
      this.initSpecialContactData()
    },
    closeContact() {
      this.contactShow = false
    },
    openContact() {
      this.contactShow = true
    },
    closeSpecialContact() {
      this.specialContactShow = false
    },
    async initSpecialContactData() {
      let that = this
      let getFindCleaningDriverUrl = CONFIG.requestName + that.$apiOpt.findCleaningDriver
      let carResult = await that.$apiUtils.get(getFindCleaningDriverUrl, {
        customerId: this.customerId
      })
      //console.log(carResult);
      this.cleanCars = carResult
      if (this.specialContactType == 'car') {
        //车辆司机接口

        let specialPhoneBook = {}
        let wordList = [
          'a',
          'b',
          'c',
          'd',
          'e',
          'f',
          'g',
          'h',
          'i',
          'j',
          'k',
          'l',
          'm',
          'n',
          'o',
          'p',
          'q',
          'r',
          's',
          't',
          'u',
          'v',
          'w',
          'x',
          'y',
          'z'
        ]
        wordList.forEach(item => {
          if (!specialPhoneBook || !specialPhoneBook[item] || specialPhoneBook[item].length == 0) {
            specialPhoneBook[item] = new Array()
          }
        })

        carResult.forEach(item => {
          let code = Pinyin.getWordsCode(item.name).substr(0, 1)
          specialPhoneBook[code].push(item)
        })
        this.specialPhoneBook = specialPhoneBook
      } else {
        this.lastCamDataTransBack = ''
        this.specialPhoneBook = {}
        if (this.specialPhoneBookJson) {
          this.specialPhoneBook = JSON.parse(this.specialPhoneBookJson)
        }

        if (CamTransBackFunc) {
          CamTransBackFunc()
        }
      }
    },
    async CamDataTransBackFunc(longitude, latitude) {
      if ((this.lastCamDataTransBack && new Date().getTime() - this.lastCamDataTransBack < 20000) || this.specialContactType == 'car') {
        this.lastCamDataTransBack = new Date().getTime()
        return
      }
      this.lastCamDataTransBack = new Date().getTime()
      let that = this
      console.log(longitude, latitude)
      let getFindRecentContactsUrl = CONFIG.requestName + this.$apiOpt.findRecentContacts
      let resultList = await this.$apiUtils.get(getFindRecentContactsUrl, {
        customerId: this.customerId,
        longitude: longitude,
        latitude: latitude
      })
      console.log(resultList)

      let getAddressBookUrl = CONFIG.requestName + that.$apiOpt.addressBook
      let result = await that.$apiUtils.get(getAddressBookUrl, {
        customerId: this.customerId
      })

      let specialPhoneBook = {}
      let wordList = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
      ]
      wordList.forEach(item => {
        if (!specialPhoneBook || !specialPhoneBook[item] || specialPhoneBook[item].length == 0) {
          specialPhoneBook[item] = new Array()
        }
      })

      let onlinePersonList = []
      let nearlyName = []
      resultList.forEach(item => {
        if (item.distance < 2000) {
          nearlyName.push(item.name)
        }
      })
      /*let randomLen = Math.floor(Math.random() * 3) + 1;*/
      let randomPerson = []
      let randomPersonShort = []
      result.forEach(item => {
        if (item.status == 1) {
          onlinePersonList.push(item)
        }
      })

      for (let i = 0; i < onlinePersonList.length; i++) {
        if ($.inArray(onlinePersonList[i].name, nearlyName) >= 0) {
          randomPerson.push(onlinePersonList[i])
          if (randomPersonShort.length < 1) {
            randomPersonShort.push(onlinePersonList[i].name)
          }
        }
        /*if (onlinePersonList.length > 0) {
          let idx = Math.floor(Math.random() * onlinePersonList.length);
          let tmpPerson = onlinePersonList.splice(idx, 1);
          if (tmpPerson.length > 0) {
            randomPerson.push(tmpPerson[0]);
            if (randomPersonShort.length < 1) {
              randomPersonShort.push(tmpPerson[0].name);
            }
          }
        }*/
      }
      this.randomPerson = randomPerson
      if (this.specialContactType == 'nearly') {
        randomPerson.forEach(item => {
          let code = Pinyin.getWordsCode(item.name).substr(0, 1)

          if (specialPhoneBook && specialPhoneBook[code] && specialPhoneBook[code].push) {
            specialPhoneBook[code].push(item)
          }
        })
        this.specialPhoneBookJson = JSON.stringify(specialPhoneBook)
      }
      /*if (this.onlinePersonStr && this.onlinePersonStr == randomPersonShort.join("、")) {
        return;
      }*/
      this.onlinePersonStr = randomPersonShort.join('、')
      this.specialPhoneBook = specialPhoneBook
    },
    async initContactData() {
      let that = this

      let getAddressBookUrl = CONFIG.requestName + that.$apiOpt.addressBook
      let result = await that.$apiUtils.get(getAddressBookUrl, {
        customerId: this.customerId
      })

      this.phoneBook = {}
      //this.specialPhoneBook = {};
      let wordList = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z'
      ]
      wordList.forEach(item => {
        if (!this.phoneBook || !this.phoneBook[item] || this.phoneBook[item].length == 0) {
          this.phoneBook[item] = new Array()
        }
      })

      /*wordList.forEach((item) => {
        if (
          !this.specialPhoneBook ||
          !this.specialPhoneBook[item] ||
          this.specialPhoneBook[item].length == 0
        ) {
          this.specialPhoneBook[item] = new Array();
        }
      });*/

      if (this.contactType == 'online' || this.contactType == 'offline') {
        console.log(result)
        result.forEach(item => {
          if (this.contactType == 'online' && item.status === 0) {
          } else {
            let code = Pinyin.getWordsCode(item.name).substr(0, 1)
            if (this.phoneBook && this.phoneBook[code] && this.phoneBook[code].push) {
              this.phoneBook[code].push(item)
            }
          }
        })
      }

      let onlinePersonList = []
      //let randomLen = Math.floor(Math.random() * 3) + 1;
      //let randomPerson = [];
      //let randomPersonShort = [];
      result.forEach(item => {
        if (item.status == 1) {
          onlinePersonList.push(item)
        }
      })
      /*for (let i = 0; i < randomLen; i++) {
        if (onlinePersonList.length > 0) {
          let idx = Math.floor(Math.random() * onlinePersonList.length);
          let tmpPerson = onlinePersonList.splice(idx, 1);
          if (tmpPerson.length > 0) {
            randomPerson.push(tmpPerson[0]);
            if (randomPersonShort.length < 1) {
              randomPersonShort.push(tmpPerson[0].name);
            }
          }
        }
      }
      this.randomPerson = randomPerson;
      if (this.specialContactType == "nearly") {
        randomPerson.forEach((item) => {
          let code = Pinyin.getWordsCode(item.name).substr(0, 1);

          if (
            this.specialPhoneBook &&
            this.specialPhoneBook[code] &&
            this.specialPhoneBook[code].push
          ) {
            this.specialPhoneBook[code].push(item);
          }
        });
      }*/
      //this.onlinePersonStr = randomPersonShort.join("、");
    },
    initContactList() {
      $('.contactList').sliderNav()
      $('.specialContactList').sliderNav()
      /*$("#transformers").sliderNav({
        items: ["autobots", "decepticons"],
        debug: true,
        height: "500",
        arrows: false,
      });*/
    },
    async INIT_RTM_RTC() {
      let that = this
      let tokenResult = await this.getRTM_Token()
      console.log(tokenResult)
      this.agoraRTM_Options.token = tokenResult

      let rtcUID = parseInt(Math.random() * 1000)
      agoraRTC_Options.uid = rtcUID
      let rtcTokenResult = await this.getRTC_Token(rtcUID)
      agoraRTC_Options.token = rtcTokenResult

      //声网云信令
      let AgoraRTM_client = AgoraRTM.createInstance(AgoraRTM_appID)
      this.RTMclient = AgoraRTM_client

      AgoraRTM_client.on('RemoteInvitationReceived', function (remoteInvitation) {
        console.log(remoteInvitation)

        let peerId = remoteInvitation.callerId
        let peerName = ''
        let channelId = remoteInvitation._channelId
        let phoneBook = that.phoneBook
        for (let i in phoneBook) {
          for (let j = 0; j < phoneBook[i].length; j++) {
            let tmpObj = phoneBook[i][j]
            if (tmpObj.account == peerId) {
              peerName = tmpObj.name
              break
            }
          }
        }

        let mathRoadContainer = $(that.$refs.mathRoad_container)
        if (mathRoadContainer.find('.call_in_' + peerId).length == 0) {
          let callInDiv = $("<div class='call_in call_in_" + peerId + "'></div>")
          let callInName = $("<span class='call_in_name'>" + peerName + '呼叫</span>')
          let callInGet = $("<div class='call_in_get'></div>")
          let callDonwGet = $("<div class='call_in_down'></div>")
          callInDiv.css('top', 130 + mathRoadContainer.find('.call_in_' + peerId).length * 100)
          callInDiv.append(callInName)

          callInDiv.append(callDonwGet)
          callInDiv.append(callInGet)
          callInGet.unbind('click')
          callInGet.bind('click', () => {
            if (that.getRemoteContactWin() >= 3) {
              ElMessage.error('最多支持3路视频通道!')
              return
            }
            callInDiv.remove()
            remoteInvitation.accept()
            that.agoraRTC_JOIN()
            if (ParseRoamFunc) {
              ParseRoamFunc()
            }
          })
          callDonwGet.unbind('click')
          callDonwGet.bind('click', () => {
            console.log(remoteInvitation)
            callInDiv.remove()
            remoteInvitation.refuse()
          })
          mathRoadContainer.append(callInDiv)
        }

        remoteInvitation.on('RemoteInvitationRefused', (newState, reason) => {
          console.log('reason', reason)
          if (mathRoadContainer.find('.call_in_' + peerId).length > 0) {
            mathRoadContainer.find('.call_in_' + peerId).remove()
          }
        })

        /*if ($(that.$refs.agoraRTC_remoteVideoBar).children().length >= 3) {
          ElMessage.error("最多支持3路视频通道!");
          return;
        }
        remoteInvitation.accept();
        if (ParseRoamFunc) {
          ParseRoamFunc();
        }
        that.agoraRTC_JOIN();*/
        //that.agoraRTM_call(peerId, peerName);
      })
      // 客户端事件监听
      // 显示对端发送的消息
      AgoraRTM_client.on('MessageFromPeer', function (message, peerId) {
        console.log('Message from: ' + peerId + ' Message: ' + message)
      })
      // 显示连接状态变化
      AgoraRTM_client.on('ConnectionStateChanged', function (state, reason) {
        console.log('State changed To: ' + state + ' Reason: ' + reason)
      })

      let AgoraRTM_channel = AgoraRTM_client.createChannel(AgoraRTM_channelID)
      AgoraRTM_channel.on('ChannelMessage', function (message, memberId) {
        console.log('Message received from: ' + memberId + ' Message: ' + message)
      })
      // 显示频道
      AgoraRTM_channel.on('MemberJoined', function (memberId) {
        console.log(memberId + ' joined the channel')
      })
      // 频道成员
      AgoraRTM_channel.on('MemberLeft', function (memberId) {
        console.log(memberId + ' left the channel')
      })
      this.getAgoraRTM_loginJoin(AgoraRTM_client, AgoraRTM_channel)
      $('.s_fiter').find('.s_txt').unbind('keypress')
      $('.s_fiter')
        .find('.s_txt')
        .bind('keypress', () => {
          if (event.keyCode == 13) {
            let contentVal = $('.s_fiter').find('.s_txt').val()
            this.getTranslateFunc(contentVal)
          }
          //this.agoraRTM_sendMsg(AgoraRTM_client, "测试内容", "ruifeng_admin");
          //this.agoraRTM_call(AgoraRTM_client, "ruifeng_admin");
        })

      //agoraRTC_Options.uid = parseInt(Math.random() * 10000);
      //
    },
    async getRTC_Token(userAccount) {
      let that = this
      let getTokenByAccountFunc = CONFIG.requestName + that.$apiOpt.tokenByAccount
      let result = await that.$apiUtils.get(getTokenByAccountFunc, {
        channelName: AgoraRTM_channelID,
        userAccount: userAccount
      })
      return result
    },
    async getRTM_Token() {
      let that = this
      let getTokenRtmByUserIdFunc = CONFIG.requestName + that.$apiOpt.tokenRtmByUserId
      let result = await that.$apiUtils.get(getTokenRtmByUserIdFunc, {
        userId: this.agoraRTM_Options.uid
      })
      return result
    },
    async getMicroStatus() {
      let that = this
      /*this.microStatus = false;*/
      /*let getFindMicrophoneFunc = CONFIG.requestName + that.$apiOpt.findMicrophone;
      let result = await that.$apiUtils.get(getFindMicrophoneFunc, {
        customerId: that.$store.state.customerId,
        loginName: bmeConfig.loginName ? bmeConfig.loginName : "",
      });*/

      window.$ajax
        .get(`/${window.CONFIG.requestName}/voiceThreeMap/findMicrophone`, {
          customerId: that.$store.state.customerId,
          loginName: bmeConfig.loginName ? bmeConfig.loginName : ''
        })
        .then(result => {
          if (!result || !result.is_true || result.is_true === 'false') {
            /*this.microStatus = false;*/

            this.microTimer = setTimeout(() => {
              this.getMicroStatus()
            }, 5000)
          } else {
            /*this.microStatus = true;
            this.$forceUpdate();*/
            if ($(this.$refs.microStatusBar).length > 0) {
              $(this.$refs.microStatusBar).css('opacity', 1)
              if (this.fadeTimer) {
                clearTimeout(this.fadeTimer)
              }
              this.fadeTimer = setTimeout(() => {
                if ($(this.$refs.microStatusBar).length > 0) {
                  $(this.$refs.microStatusBar).css('opacity', 0)
                }
              }, 5000)
            }

            this.microTimer = setTimeout(() => {
              this.getMicroStatus()
            }, 5000)
          }
        })
    },
    async getTranslateData() {
      let that = this
      let getFindInstructionFunc = CONFIG.requestName + that.$apiOpt.findInstruction
      let result = await that.$apiUtils.get(getFindInstructionFunc, {
        customerId: that.$store.state.customerId,
        loginName: bmeConfig.loginName ? bmeConfig.loginName : ''
      })
      if (result != '暂无最新指令') {
        if (result.oldValue) {
          $('.s_fiter').find('.s_txt').val(result.oldValue)
          $('.o_txt').html(result.oldValue)
        }
        this.translateResultDeal(result)
      }
    },
    async getTranslateFunc(val) {
      let that = this
      let getFindTargetFunc = CONFIG.requestName + that.$apiOpt.findTarget
      let result = await that.$apiUtils.get(getFindTargetFunc, {
        customerId: that.$store.state.customerId,
        value: val
      })
      this.translateResultDeal(result)
      //return result;
    },
    async callDown() {
      this.isCalling = false
      this.$forceUpdate()
      this.localInvitation.forEach(item => {
        item.val && item.val.cancel()
      })
      this.localInvitation = []
      //this.localInvitation && this.localInvitation.cancel();
      //await this.agoraRTC_LEAVE();
    },
    async translateResultDeal(result) {
      if (result.isTrue === 'true') {
        //console.log(result);
        if (result.keyType === '设备列表') {
          if (result.oldValue && result.oldValue.indexOf('关闭') >= 0) {
            //this.$store.
            this.closePopup()
          } else {
            //
            if (this.factoryId != result.relativeKey) {
              this.factoryDetailShow = false
              await this.roadVisionFunc([{ id: result.relativeKey, location: 0 }])
            }
            this.goToPopup()
          }
        } else if (result.keyType === '自定义巡查') {
          this.customRoutePlay()
        } else if (result.keyType === '重点巡查') {
          this.keyPointRoutePlay()
        } else if (result.keyType === '日常巡查') {
          this.dailyRoutePlay()
        } else if (result.keyType === '自定义巡查报告') {
          this.customRouteReport()
        } else if (result.keyType === '重点巡查报告') {
          this.keyPointRouteReport()
        } else if (result.keyType === '日常巡查报告') {
          this.dailyRouteReport()
        } else if (result.keyType === '巡查关闭') {
          /*if (window.EasySlidesTimer) {
            clearTimeout(window.EasySlidesTimer);
          }
          this.reportShow = false;*/
          this.closeReport()
        } else if (result.keyType === '人员状态') {
          if (result.keyWord && result.keyWord.indexOf('在线人员') >= 0) {
            this.contactShow = true
            //this.specialContactShow = false;
            this.contactType = 'online'
            this.initContactData()
          } else if (result.keyWord && result.keyWord.indexOf('全部人员') >= 0) {
            this.contactShow = true
            //this.specialContactShow = false;
            this.contactType = 'offline'
            this.initContactData()
          } else if (result.keyWord && result.keyWord.indexOf('司机') >= 0) {
            //this.contactShow = false;
            this.specialContactShow = true
            this.specialContactType = 'car'
            this.initSpecialContactData()
          } else if (result.keyWord && result.keyWord.indexOf('附近') >= 0) {
            //this.contactShow = false;
            this.specialContactShow = true
            this.specialContactType = 'nearly'
            this.initSpecialContactData()
            //this.initContactData();
          }
        } else if (result.keyType === '设备列表关闭') {
          this.closePopup()
        } else if (result.keyType === '清单列表') {
          if (result.oldValue && result.oldValue.indexOf('关闭') >= 0) {
            this.closeEmission()
          } else {
            if (this.factoryId != result.relativeKey) {
              this.factoryDetailShow = false
              await this.roadVisionFunc([{ id: result.relativeKey, location: 0 }])
            }
            this.getEmissionTable()
          }
        } else if (result.keyType === '清单列表关闭') {
          this.closeEmission()
        } else if (result.keyType === '区域详情') {
          if (this.factoryId != result.relativeKey) {
            this.factoryDetailShow = false
            await this.roadVisionFunc([{ id: result.relativeKey, location: 0 }])
          }
        } else if (result.keyType === '清单详情') {
          if (result.relativeKey) {
            this.deviceStatus = true
            this.$forceUpdate()
            /*this.updateFactoryArea(this.branchFactoryId, this.emNameVal, true);*/
            if (result.oldValue && (result.oldValue.indexOf('动态') >= 0 || result.oldValue.indexOf('历史') >= 0)) {
              this.$nextTick(() => {
                this.updateDutyInventoryId({
                  inventoryId: result.relativeKey,
                  inventoryName: result.relativeValue,
                  inventoryBar: '2'
                })
              })
            } else {
              this.$nextTick(() => {
                this.updateDutyInventoryId({
                  inventoryId: result.relativeKey,
                  inventoryName: '',
                  inventoryBar: '1'
                })
              })
            }
          }
        } else if (result.keyType === '清单基本信息') {
          if (result.relativeKey) {
            this.deviceStatus = true
            this.$forceUpdate()
            this.$nextTick(() => {
              this.updateDutyInventoryId({
                inventoryId: result.relativeKey,
                inventoryName: '',
                inventoryBar: '1'
              })
            })
          }
        } else if (result.keyType === '清单动态数据') {
          if (result.relativeKey) {
            this.deviceStatus = true
            this.$forceUpdate()
            this.$nextTick(() => {
              this.updateDutyInventoryId({
                inventoryId: result.relativeKey,
                inventoryName: '',
                inventoryBar: '2'
              })
            })
          }
        } else if (result.keyType === '清单详情关闭') {
          $('.bringins-block').fadeOut(500)
          this.deviceStatus = false
          this.$forceUpdate()
        } else if (result.keyType === '设备详情') {
        } else if (result.keyType === '设备详情关闭') {
        } else if (result.keyType === '通讯录') {
          if (result.oldValue && result.oldValue.indexOf('关') >= 0) {
            this.contactShow = false
          } else {
            this.contactShow = true
          }
        } else if (result.keyType === '通讯录关闭') {
          this.contactShow = false
        } else if (result.keyType === '通讯录通话') {
          if (result.oldValue && (result.oldValue.indexOf('关闭') >= 0 || result.oldValue.indexOf('结束') >= 0)) {
            let relativeKey = result.relativeKey
            if (this.rtcCallTimer) {
              clearTimeout(this.rtcCallTimer)
            }
            this.rtcCallTimer = setTimeout(() => {
              this.callDown()
              this.agoraRTC_LEAVE_CN(relativeKey)
            }, 1000)
          } else {
            let relativeKey = result.relativeKey
            if (this.rtcCallTimer) {
              clearTimeout(this.rtcCallTimer)
            }
            this.rtcCallTimer = setTimeout(() => {
              this.agoraRTM_call(relativeKey)
              this.callPerson = result.relativeValue
            }, 1000)
          }
        } else if (result.keyType === '附近人员关闭') {
          this.closeSpecialContact()
        } else if (result.keyType === '结束日常巡查') {
          this.normalPlay()
        } else if (result.keyType === '结束重点巡查') {
          this.normalPlay()
        } else if (result.keyType === '结束自定义巡查') {
          this.normalPlay()
        } else if (result.keyType === '通话关闭') {
          this.callDown()
          await this.agoraRTC_LEAVE()
        } else if (result.keyType === '停止') {
          if (ParseRoamFunc) {
            this.isOrbitVision = true
            window.isOrbitVision = true
            ParseRoamFunc(true)
          }
        } else if (result.keyType === '前进') {
          if (ContinueRoamFunc) {
            this.isOrbitVision = false
            window.isOrbitVision = false
            ContinueRoamFunc()
          }
        } else if (result.keyType === '加速') {
          this.slowRate = bmeConfig.fastRate ? Math.ceil(parseInt(bmeConfig.fastRate) * 2) : 4
          this.fastRate = bmeConfig.fastRate ? Math.ceil(parseInt(bmeConfig.fastRate) * 2) : 6
          ChangeFlySpeedFunc(this.fastRate)
        } else if (result.keyType === '减速') {
          this.slowRate = bmeConfig.slowRate ? Math.ceil(parseInt(bmeConfig.slowRate) / 2) : 4
          this.fastRate = bmeConfig.slowRate ? Math.ceil(parseInt(bmeConfig.slowRate) / 2) : 6
          ChangeFlySpeedFunc(this.slowRate)
        } else if (result.keyType === '正常速') {
          this.slowRate = bmeConfig.slowRate ? Math.ceil(parseInt(bmeConfig.slowRate) * 1) : 4
          this.fastRate = bmeConfig.slowRate ? Math.ceil(parseInt(bmeConfig.slowRate) * 1) : 6
          ChangeFlySpeedFunc(this.fastRate)
        } else if (result.keyType === '方位') {
          let pastRoadNameList = bmeConfig.pastRoadNameList
          let pastRoadNameObj = {}
          for (let i in pastRoadNameList) {
            let keyWord = pastRoadNameList[i]
            if ($.isEmptyObject(pastRoadNameObj[keyWord])) {
              pastRoadNameObj[keyWord] = []
            }
            pastRoadNameObj[keyWord].push(i)
          }
          let roadList = []
          let roadName = ''
          for (let i in pastRoadNameObj) {
            if (!i) {
              continue
            }
            if (result.relativeKey.indexOf(i) >= 0) {
              roadList = pastRoadNameObj[i]
              roadName = i
              break
            }
          }
          if (roadList && roadList.length > 0) {
            let tmpIdx = Math.floor(roadList.length * Math.random())
            let beginRoadId = roadList[tmpIdx]

            //结束巡航
            if (ExitCruiseFunc) {
              ExitCruiseFunc()
            }

            setTimeout(() => {
              LoadCruiseJsonFunc()
              setTimeout(() => {
                LoadCruiseNetworkFunc()
                setTimeout(() => {
                  let cruiseJsonObj = {
                    name: beginRoadId,
                    head: 'true'
                  }
                  window.cruiseJson = JSON.stringify(cruiseJsonObj)
                  StartCruiseFunc()
                  setTimeout(() => {
                    SwitchPauseTriggerFunc('false')
                    if (roadName) {
                      this.roadName = roadName
                      $(this.$refs.roadBar).show()
                    } else {
                      this.roadName = '未命名道路'
                      $(this.$refs.roadBar).show()
                    }
                  }, 50)
                }, 50)
              }, 50)
            }, 1000)
          }
          /*if (result.relativeKey === "快进") {
            this.slowRate = bmeConfig.fastRate
              ? Math.ceil(parseInt(bmeConfig.fastRate) * 2)
              : 4;
            this.fastRate = bmeConfig.fastRate
              ? Math.ceil(parseInt(bmeConfig.fastRate) * 2)
              : 6;
            ChangeFlySpeedFunc(this.fastRate);
          } else if (result.relativeKey === "慢速") {
            this.slowRate = bmeConfig.slowRate
              ? Math.ceil(parseInt(bmeConfig.slowRate) / 2)
              : 4;
            this.fastRate = bmeConfig.slowRate
              ? Math.ceil(parseInt(bmeConfig.slowRate) / 2)
              : 6;
            ChangeFlySpeedFunc(this.slowRate);
          } else if (
            result.relativeKey === "正常速" ||
            (result.oldValue && result.oldValue.indexOf("正常速") >= 0)
          ) {
            this.slowRate = bmeConfig.slowRate
              ? Math.ceil(parseInt(bmeConfig.slowRate) * 1)
              : 4;
            this.fastRate = bmeConfig.fastRate
              ? Math.ceil(parseInt(bmeConfig.fastRate) * 1)
              : 6;
            ChangeFlySpeedFunc(this.fastRate);
          } else if (
            result.relativeKey &&
            result.relativeKey.indexOf("前往") >= 0
          ) {

          }*/
        } else if (result.keyType === '层级关闭') {
          if (result.oldValue && (result.oldValue.indexOf('视频') >= 0 || result.oldValue.indexOf('通话') >= 0)) {
            this.callDown()
            await this.agoraRTC_LEAVE()
          } else if (result.oldValue && (result.oldValue.indexOf('通讯录') >= 0 || result.oldValue.indexOf('电话本') >= 0)) {
            this.contactShow = false

            /*let playerContainerList = $(this.$refs.agoraRTC_remoteVideoBar).children();
            let playerContainer = $(playerContainerList.get(0));
            playerContainer && playerContainer.remove();*/
          } else if (result.keyWord === '关闭设备列表') {
            this.closePopup()
          } else if (result.oldVal && result.oldVal.indexOf('排放源') >= 0) {
            this.closeEmission()
          } else if (result.oldVal && result.oldVal.indexOf('排放源详情') >= 0) {
            this.deviceStatus = false
          }
        }
      }
    },
    async agoraRTC_JOIN() {
      let that = this

      console.log(agoraRTC_Options)
      await agoraRTC_Settings.client.join(agoraRTC_Options.appId, agoraRTC_Options.channel, agoraRTC_Options.token, agoraRTC_Options.uid)
      // Create a local audio track from the audio sampled by a microphone.
      agoraRTC_Settings.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack()
      // Create a local video track from the video captured by a camera.
      //agoraRTC_Settings.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
      // Publish the local audio and video tracks to the RTC channel.
      await agoraRTC_Settings.client.publish([
        agoraRTC_Settings.localAudioTrack
        //agoraRTC_Settings.localVideoTrack,
      ])
      // Dynamically create a container in the form of a DIV element for playing the local video track.
      const localPlayerContainer = document.createElement('div')
      // Specify the ID of the DIV container. You can use the uid of the local user.
      localPlayerContainer.id = agoraRTC_Options.uid
      localPlayerContainer.textContent = 'Local user ' + agoraRTC_Options.uid
      localPlayerContainer.style.width = '420px'
      localPlayerContainer.style.height = '320px'
      $(that.$refs.agoraRTC_localVideoBar).append(localPlayerContainer)
      $(that.$refs.agoraRTC_localVideoBar).show()

      // Play the local video track.
      // Pass the DIV container and the SDK dynamically creates a player in the container for playing the local video track.
      agoraRTC_Settings.localVideoTrack && agoraRTC_Settings.localVideoTrack.play(localPlayerContainer)
      console.log('publish success!')
    },
    async agoraRTM_leave_CN(name) {
      let childAccount = await this.getChildAccount(name)
      console.log(childAccount)
      this.callPerson = childAccount.name ? childAccount.name : name

      let listSon = childAccount.listSon
      listSon.push({
        token: childAccount.account
      })
      // 创建 LocalInvitation
      listSon.forEach(item => {
        this.agoraRTC_LEAVE(item.token)
      })
    },
    async agoraRTC_LEAVE_CN(name) {
      let childAccount = await this.getChildAccount(name)
      console.log(childAccount)
      this.callPerson = childAccount.name ? childAccount.name : name

      let listSon = childAccount.listSon
      listSon.push({
        token: childAccount.account
      })
      listSon.forEach(item => {
        this.agoraRTC_LEAVE(item.token)
      })
    },
    async agoraRTC_LEAVE(peerId, leaveAutoVision) {
      // Traverse all remote users.
      if (peerId) {
        let playerContainer = document.getElementById(peerId)
        playerContainer && playerContainer.remove()
        if (this.getRemoteContactWin() === 0) {
          // Destroy the local audio and video tracks.
          agoraRTC_Settings.localAudioTrack && agoraRTC_Settings.localAudioTrack.close && agoraRTC_Settings.localAudioTrack.close()
          agoraRTC_Settings.localVideoTrack && agoraRTC_Settings.localVideoTrack.close && agoraRTC_Settings.localVideoTrack.close()
          let playerContainer = document.getElementById(agoraRTC_Options.uid)
          playerContainer && playerContainer.remove()
          $(this.$refs.agoraRTC_localVideoBar).hide()

          $(this.$refs.agoraRTC_remoteVideoBar).hide()
          // Leave the channel.
          await agoraRTC_Settings.client.leave()
          if (ContinueRoamFunc && !leaveAutoVision) {
            ContinueRoamFunc()
          }
        }
      } else {
        // Destroy the local audio and video tracks.
        agoraRTC_Settings.localAudioTrack && agoraRTC_Settings.localAudioTrack.close && agoraRTC_Settings.localAudioTrack.close()
        agoraRTC_Settings.localVideoTrack && agoraRTC_Settings.localVideoTrack.close && agoraRTC_Settings.localVideoTrack.close()
        let playerContainer = document.getElementById(agoraRTC_Options.uid)
        playerContainer && playerContainer.remove()
        $(this.$refs.agoraRTC_localVideoBar).hide()

        agoraRTC_Settings.client &&
          agoraRTC_Settings.client.remoteUsers &&
          agoraRTC_Settings.client.remoteUsers.forEach(user => {
            // Destroy the dynamically created DIV containers.
            let playerContainer = document.getElementById(user.uid)
            playerContainer && playerContainer.remove()
          })
        $(this.$refs.agoraRTC_remoteVideoBar).hide()

        // Leave the channel.
        await agoraRTC_Settings.client.leave()
        if (ContinueRoamFunc && !leaveAutoVision) {
          ContinueRoamFunc()
        }
      }
    },
    async startBasicCall() {
      let that = this
      // Create an AgoraRTCClient object.
      agoraRTC_Settings.client = AgoraRTC.createClient({
        mode: 'rtc',
        codec: 'vp8'
      })
      agoraRTC_Settings.client.on('user-published', async (user, mediaType) => {
        this.isCalling = false
        // Subscribe to the remote user when the SDK triggers the "user-published" event
        await agoraRTC_Settings.client.subscribe(user, mediaType)
        console.log('subscribe success')

        // If the remote user publishes a video track.
        if (mediaType === 'video' && user && user.videoTrack) {
          // Get the RemoteVideoTrack object in the AgoraRTCRemoteUser object.
          const remoteVideoTrack = user.videoTrack
          // Dynamically create a container in the form of a DIV element for playing the remote video track.
          /*const remotePlayerContainer = document.createElement("div");
          //const remotePlayerContainer = that.$refs.agoraRTC_videoBar;
          // Specify the ID of the DIV container. You can use the uid of the remote user.
          remotePlayerContainer.id = user.uid.toString();
          remotePlayerContainer.textContent = "通话中..."; //"呼叫用户 " + this.callPerson;
          remotePlayerContainer.style.width = "800px";
          remotePlayerContainer.style.height = "600px";
          $(remotePlayerContainer).attr("class", "contact-bar");
          $(that.$refs.agoraRTC_remoteVideoBar).append(remotePlayerContainer);
          $(that.$refs.agoraRTC_remoteVideoBar).show();
          that.isCalling = false;
          that.$forceUpdate();
          //document.body.append(remotePlayerContainer);*/

          const remotePlayerContainer = document.createElement('div')
          //const remotePlayerContainer = that.$refs.agoraRTC_videoBar;
          // Specify the ID of the DIV container. You can use the uid of the remote user.
          remotePlayerContainer.id = user.uid.toString() //user.uid.toString();
          $(remotePlayerContainer).attr('class', 'contact-bar')
          remotePlayerContainer.textContent = '' //"呼叫用户 " + this.callPerson;
          remotePlayerContainer.style.width = '800px'
          remotePlayerContainer.style.height = '600px'
          $(this.$refs.agoraRTC_remoteVideoBar).append(remotePlayerContainer)
          let remoteList = $(this.$refs.agoraRTC_remoteVideoBar).children()
          if (remoteList.length == 1) {
            $(remotePlayerContainer).css('marginTop', '120px')
            let playerContainerBtn = document.createElement('div')
            $(playerContainerBtn).attr('class', 'playerContainerBtn')
            remotePlayerContainer.append(playerContainerBtn)
            $(playerContainerBtn).bind('click', () => {
              this.agoraRTC_LEAVE(user.uid.toString())
            })
          } else if (remoteList.length == 2) {
            $(remotePlayerContainer).css('marginTop', '-100px')
            $(remotePlayerContainer).css('marginLeft', '-1000px')
            let playerContainerBtn = document.createElement('div')
            $(playerContainerBtn).attr('class', 'playerContainerBtn')
            remotePlayerContainer.append(playerContainerBtn)
            $(playerContainerBtn).bind('click', () => {
              this.agoraRTC_LEAVE(user.uid.toString())
            })
          } else if (remoteList.length == 3) {
            $(remotePlayerContainer).css('marginTop', '-100px')
            $(remotePlayerContainer).css('marginLeft', '1000px')
            let playerContainerBtn = document.createElement('div')
            $(playerContainerBtn).attr('class', 'playerContainerBtn')
            remotePlayerContainer.append(playerContainerBtn)
            $(playerContainerBtn).bind('click', () => {
              this.agoraRTC_LEAVE(user.uid.toString())
            })
          }
          $(this.$refs.agoraRTC_remoteVideoBar).show()

          // Play the remote video track.
          // Pass the DIV container and the SDK dynamically creates a player in the container for playing the remote video track.
          remoteVideoTrack.play(remotePlayerContainer)

          // Or just pass the ID of the DIV container.
          // remoteVideoTrack.play(playerContainer.id);
        }

        // If the remote user publishes an audio track.
        if (mediaType === 'audio' && user && user.audioTrack) {
          // Get the RemoteAudioTrack object in the AgoraRTCRemoteUser object.
          const remoteAudioTrack = user.audioTrack
          // Play the remote audio track. No need to pass any DOM element.
          remoteAudioTrack.play()
        }

        // Listen for the "user-unpublished" event
        agoraRTC_Settings.client.on('user-unpublished', user => {
          // Get the dynamically created DIV container.
          if (!user._audioTrack && !user._videoTrack) {
            this.agoraRTC_LEAVE(user.uid)
          }

          /*const remotePlayerContainer = document.getElementById(user.uid);
          // Destroy the container.
          if (remotePlayerContainer && remotePlayerContainer.remove) {
            remotePlayerContainer.remove();
          }
          $(that.$refs.agoraRTC_remoteVideoBar).hide();

          const playerContainer = document.getElementById(agoraRTC_Options.uid);
          playerContainer && playerContainer.remove();
          $(that.$refs.agoraRTC_localVideoBar).hide();*/
        })
      })

      // Listen for the "user-published" event, from which you can get an AgoraRTCRemoteUser object.
    },
    async getAgoraRTM_loginJoin(client, channel) {
      await client.login(this.agoraRTM_Options)
      await channel.join().then(() => {
        console.log('You have successfully joined channel ' + channel.channelId)
      })
    },
    async agoraRTM_sendMsg(client, peerMessage, peerId) {
      await client.sendMessageToPeer({ text: peerMessage }, peerId).then(sendResult => {
        if (sendResult.hasPeerReceived) {
          console.log('Message has been received by: ' + peerId + ' Message: ' + peerMessage)
        } else {
          console.log('Message sent to: ' + peerId + ' Message: ' + peerMessage)
        }
      })
    },
    async getChildAccountApp(peerId) {
      let findUserAccountAppUrl = CONFIG.requestName + this.$apiOpt.findUserAccountApp
      let result = await this.$apiUtils.get(findUserAccountAppUrl, {
        account: peerId
      })
      return result
    },
    async agoraRTM_call(peerId, name) {
      if (this.getRemoteContactWin() >= 3) {
        ElMessage.error('最多支持3路视频通道!')
        return
      }
      if (ParseRoamFunc) {
        ParseRoamFunc()
      }
      this.isCalling = true
      //this.callPerson = name;
      this.$forceUpdate()

      let childAccount = await this.getChildAccountApp(peerId)
      console.log(childAccount)
      this.callPerson = childAccount.name ? childAccount.name : name

      let listSon = childAccount.listSon

      listSon.push({
        token: peerId
      })

      let that = this

      listSon.forEach(item => {
        // 创建 LocalInvitation
        if (item.token) {
          let localInvitation = this.RTMclient.createLocalInvitation(item.token)
          this.localInvitation.push({
            key: item.token,
            val: localInvitation
          })
          localInvitation.channelId = agoraRTC_Options.channel

          // 发送呼叫邀请
          localInvitation.send()
          localInvitation.on('LocalInvitationAccepted', function (response) {
            console.log('Message received from:  Message: ' + response)
            that.agoraRTC_JOIN()
          })

          localInvitation.on('LocalInvitationRefused', function (newState, reason) {
            console.log('reason', reason)
            that.isCalling = false
            that.$forceUpdate()
            if (that.getRemoteContactWin() === 0) {
              if (ContinueRoamFunc) {
                ContinueRoamFunc()
              }
            }
          })
        }
      })
    },
    async getChildAccount(name) {
      let findUserAccountUrl = CONFIG.requestName + this.$apiOpt.findUserAccount
      let result = await this.$apiUtils.get(findUserAccountUrl, {
        name: name,
        customerId: this.customerId
      })
      return result
    },
    async agoraRTM_call_CN(name) {
      if (this.getRemoteContactWin() >= 3) {
        ElMessage.error('最多支持3路视频通道!')
        return
      }
      if (ParseRoamFunc) {
        ParseRoamFunc()
      }
      let peerId = ''
      this.isCalling = true
      this.callPerson = name
      this.$forceUpdate()

      let childAccount = await this.getChildAccount(name)
      console.log(childAccount)
      this.callPerson = childAccount.name ? childAccount.name : name

      let listSon = childAccount.listSon
      listSon.push({
        token: childAccount.account
      })

      let that = this
      // 创建 LocalInvitation
      listSon.forEach(item => {
        let localInvitation = this.RTMclient.createLocalInvitation(item.token)
        //this.localInvitation = localInvitation;
        this.localInvitation.push({
          key: item.token,
          val: localInvitation
        })
        localInvitation.channelId = agoraRTC_Options.channel
        // 发送呼叫邀请
        localInvitation.send()
        localInvitation.on('LocalInvitationAccepted', function (response) {
          console.log('Message received from:  Message: ' + response)
          that.agoraRTC_JOIN()
        })

        localInvitation.on('LocalInvitationRefused', function (newState, reason) {
          console.log('reason', reason)
          that.isCalling = false
          that.$forceUpdate()
          if (that.getRemoteContactWin() === 0) {
            if (ContinueRoamFunc) {
              ContinueRoamFunc()
            }
          }
        })
      })
    },
    voiceIconAnimate(n) {
      if (!n) {
        n = 0
      }
      //microphone.volume("Microphone", 60);
      if (!this.microStatus) {
        microphone.volume('Microphone', parseInt(Math.random() * 1))
      } else {
        microphone.volume('Microphone', parseInt(Math.random() * 40))
      }

      if (this.microphoneTimer) {
        clearTimeout(this.microphoneTimer)
      }
      this.microphoneTimer = setTimeout(() => {
        this.voiceIconAnimate(n)
      }, 200)
    },
    switchOpacityVal(val) {
      this.opacityVal = val
      SetMapAlphaFunc(val)
    },
    switchMapType(arg) {
      if (this.miniMap == 'small') {
        this.miniMap = 'big'
        HideMinimapFunc()
        ShowGlobalMapFunc()
      } else if (this.miniMap == 'big') {
        this.miniMap = 'small'
        HideGlobalMapFunc()
        ShowMinimapFunc()
      }
    },
    dateTimeChange() {
      setTimeout(() => {
        CancelFixedTimeFunc()

        let timeList = []
        if (this.unity3DTime) {
          timeList = this.unity3DTime.split(':')
        }
        if (timeList.length > 0) {
          setTimeout(() => {
            let tmpTime = parseInt(timeList[0]) + '.' + parseInt(parseInt(timeList[1]) / 60)
            setDayFunc(tmpTime)
            SetFixedTimeFunc(tmpTime)
          }, 500)
        } else {
          setTimeout(() => {
            setDayFunc('8.0')
            SetFixedTimeFunc('8.0')
          }, 500)
        }
      }, 500)
    },
    async getVdmData() {
      let that = this
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: 'VDM'
      })
      window.overalVdmData = new Object()
      result.forEach(item => {
        window.overalVdmData[item.SN] = item
      })
      return result
    },
    async getPM10Data() {
      let that = this
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: 'PM10'
      })
      window.overalPM10Data = new Object()
      result.forEach(item => {
        window.overalPM10Data[item.SN] = item
      })
      return result
    },
    async getTspData() {
      let that = this
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: 'TSP'
      })
      window.overalDustData = new Object()
      result.forEach(item => {
        window.overalDustData[item.SN] = item
      })
      return result
    },
    async roadVisionFunc(factoryList, isRe) {
      if (!isRe) {
        clearTimeout(this.factoryReplayTimer)
        CloseWallFunc()
      }
      let that = this
      console.log('=====================')
      console.log(factoryList)
      if (factoryList.length == 0) {
        return
      }

      if (this.factoryDetailShow) {
        this.factoryReplayTimer = setTimeout(() => {
          this.roadVisionFunc(factoryList, true)
          this.hasNext = true
        }, 5000)
        return
      }
      this.hasNext = false

      if (this.factoryTimer) {
        clearTimeout(this.factoryTimer)
      }

      let ShowWallObj = [{ WallID: factoryList[0]['id'] }]
      //ShowWallDataFunc(JSON.stringify(ShowWallObj));

      let factoryProfileUrl = CONFIG.requestName + that.$apiOpt.factoryProfileMap
      let result = await that.$apiUtils.get(factoryProfileUrl, {
        customerId: that.$store.state.customerId,
        id: factoryList[0]['id']
      })

      let findDeviceListUrl = CONFIG.requestName + that.$apiOpt.findDeviceListAutoVision
      let resultDetail = await that.$apiUtils.get(findDeviceListUrl, {
        id: factoryList[0]['id']
      })

      this.factoryId = factoryList[0]['id']

      if (this.factoryId) {
        this.calcFactory(this.factoryId)
      }

      console.log(result)
      console.log(resultDetail)

      let equipList = []
      for (let i in resultDetail) {
        resultDetail[i].forEach(item => {
          if ($.inArray(item.deviceNo, equipList) < 0) {
            equipList.push(item.deviceNo)
          }
        })
      }
      this.resultScroll = ''
      let scrollByTimeUrl = CONFIG.requestName + that.$apiOpt.scrollByTime
      if (equipList.length > 0) {
        let resultScroll = await that.$apiUtils.get(scrollByTimeUrl, {
          customerId: that.$store.state.customerId,
          deviceNoList: equipList.join(',')
        })
        this.resultScroll = resultScroll
        console.log('resultScroll:' + resultScroll)

        $(this.$refs.factorySub).unbind('click')
        $(this.$refs.factorySub).bind('click', () => {
          this.getWarnTicket(equipList)
          if (this.playTimer) {
            clearTimeout(this.playTimer)
          }
        })
      }

      if (this.reportTypeKey == 'daily') {
        this.dailyRouteReport(factoryList[0]['id'], result.branchFactory)
      } else if (this.reportTypeKey == 'keyPoint') {
        this.keyPointRouteReport(factoryList[0]['id'], result.branchFactory)
      } else if (this.reportTypeKey == 'custom') {
        this.customRouteReport(factoryList[0]['id'], result.branchFactory)
      }

      this.branchFactory = result.branchFactory
      this.emissionSourceCount = result.emissionSourceCount ? result.emissionSourceCount : 0
      this.productDeviceCount = resultDetail.production && resultDetail.production.length ? resultDetail.production.length : 0
      this.governmentDeviceCount = resultDetail.governmen && resultDetail.governmen.length ? resultDetail.governmen.length : 0
      this.monitorDeviceCount = resultDetail.monitor && resultDetail.monitor.length ? resultDetail.monitor.length : 0
      this.facotryMonitorDeviceList = { TSP: 0, VDM: 0 }
      if (result.facotryMonitorDeviceList && result.facotryMonitorDeviceList.length > 0) {
        result.facotryMonitorDeviceList.forEach(item => {
          if (item.typeName && item.typeName.indexOf('TSP') >= 0) {
            this.facotryMonitorDeviceList['TSP'] += item.deviceCount
          } else if (item.typeName && item.typeName.indexOf('VDM') >= 0) {
            this.facotryMonitorDeviceList['VDM'] += item.deviceCount
          }
        })
      } else {
        this.facotryMonitorDeviceList['TSP'] = 0
        this.facotryMonitorDeviceList['VDM'] = 0
      }

      if (!this.monitorDeviceCount && !this.productDeviceCount && !this.treatmentCount && !this.emissionSourceCount) {
        this.noEquipBuilding = true
      } else {
        this.noEquipBuilding = false
      }

      $(this.$refs.factory).removeClass('left')
      $(this.$refs.factory).removeClass('right')
      if (this.noEquipBuilding) {
        $(this.$refs.factory).removeClass('nobulding')
      }
      $(this.$refs.factorySub).removeClass('factorySubLeft')
      $(this.$refs.factorySub).removeClass('factorySubRight')

      $(this.$refs.alarm).removeClass('leftAlarm')
      $(this.$refs.alarm).removeClass('rightAlarm')
      if (factoryList[0]['location'] === 0 || factoryList[0]['location'] === 1) {
        $(this.$refs.factory).addClass('left')
        if (this.noEquipBuilding) {
          $(this.$refs.factory).addClass('nobulding')
        }
        if (!$.isEmptyObject(this.resultScroll)) {
          $(this.$refs.factorySub).addClass('factorySubRight')
        }
        $(this.$refs.alarm).addClass('leftAlarm')
        this.factoryPos = 0
      } /*else if (factoryList[0]["location"] === 1) {
        $(this.$refs.factory).addClass("right");
        $(this.$refs.factorySub).addClass("factorySubLeft");
        $(this.$refs.alarm).addClass("rightAlarm");
        this.factoryPos = 1;
      }*/

      if (this.warnDetailShow && this.$refs.warn) {
        $(this.$refs.warn.$el).removeClass('warnLeft')
        $(this.$refs.warn.$el).removeClass('warnRight')
        if (this.factoryPos === 0) {
          $(this.$refs.warn.$el).addClass('warnRight')
        } else if (this.factoryPos === 1) {
          $(this.$refs.warn.$el).addClass('warnLeft')
        }
      }

      //this.facotryMonitorDeviceList = result.facotryMonitorDeviceList;
      this.workTicketCount = result.workTicketCount ? result.workTicketCount : 0
      this.treatmentCount = result.treatmentCount ? result.treatmentCount : 0
      this.treatmentRate = result.treatmentRate ? result.treatmentRate : 0
      this.description = result.description

      clearTimeout(this.playTimer)
      if (this.$refs.warn) {
        $(this.$refs.warn.$el).fadeOut(50, () => {
          this.warnDetailShow = false
        })
      }

      this.factoryDetailShow = true
      $(this.$refs.factory).stop(true, true)
      $(this.$refs.factorySub).stop(true, true)
      $(this.$refs.alarm).stop(true, true)

      $(this.$refs.factory).hide()
      $(this.$refs.factorySub).hide()
      $(this.$refs.alarm).hide()
      this.$forceUpdate()

      $(this.$refs.factory).fadeIn(1000)
      if (!this.noEquipBuilding) {
        $(this.$refs.alarm).fadeIn(2000)
        if (!$.isEmptyObject(this.resultScroll)) {
          $(this.$refs.factorySub).fadeIn(1000)
        }
      }

      if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
        ChangeFlySpeedFunc(this.slowRate)
      }

      if (this.$refs.factory) {
        if (this.factoryTimer) {
          clearTimeout(this.factoryTimer)
        }
        this.factoryTimer = setTimeout(
          () => {
            $(this.$refs.alarm).fadeOut(1000)
            $(this.$refs.factorySub).fadeOut(1000)
            $(this.$refs.factory).fadeOut(1000, () => {
              this.factoryDetailShow = false
              if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
                ChangeFlySpeedFunc(this.fastRate)
              }

              //CloseWallFunc();
            })

            this.closeReport()
          },
          this.hasNext ? 10000 : 18000
        )
      }
    },
    async getWarnTicket(equipList) {
      if (this.$refs.resultWarn) {
        $(this.$refs.resultWarn.$el).removeClass('warn1-large')
        $(this.$refs.resultWarn.$el).fadeOut()
        this.resultWarnTypeId = ''
      }
      let that = this
      let getWorkTicketUrl = CONFIG.requestName + this.$apiOpt.scrollThreeMap
      let resultWarn = await that.$apiUtils.get(getWorkTicketUrl, {
        customerId: that.$store.state.customerId,
        deviceNoList: equipList.join(',')
      })
      console.log(resultWarn)
      if (resultWarn && resultWarn.length > 0) {
        this.resultWarnObj = resultWarn[resultWarn.length - 1]
        this.resultWarnTypeId = resultWarn[resultWarn.length - 1].typeId

        this.$forceUpdate()
        this.$nextTick(() => {
          if (this.$refs.resultWarn) {
            $(this.$refs.resultWarn.$el).fadeIn(1000)
            $(this.$refs.resultWarn.$el).addClass('warn1-large')

            if (ParseRoamFunc) {
              ParseRoamFunc()
            }
          }
        })
      }
    },
    roadVisionEquipFunc(equipList) {
      let that = this

      /*if (!equipList || equipList.length === 0) {
        return;
      }*/

      /*if (this.playTimer) {
        clearTimeout(this.playTimer);
      }
      if (this.$refs.warn) {
        $(this.$refs.warn.$el).fadeOut(2000, () => {
          this.warnDetailShow = false;
        });
      }*/

      //console.log("333", result);
      if (!this.factoryDetailShow && !this.warnDetailShow) {
        //console.log(this.mircoList);
        let equip = this.mircoList.pop()
        if (equip) {
          this.warnList = [equip]
          if (this.warnList.length > 0) {
            this.playWarn()
          }
        }
      }
    },
    roadNameShowFunc(roadId) {
      let roadName = this.pastRoadNameObj && this.pastRoadNameObj[roadId]
      if (roadName) {
        this.roadName = roadName
        $(this.$refs.roadBar).show()
      } else {
        this.roadName = '未命名道路'
        $(this.$refs.roadBar).show()
      }
    },
    roadPushStack(list) {
      list.forEach(item => {
        if ($.inArray(item, this.mircoRepeatCheck) < 0 && $.inArray(item, this.mircoList) < 0) {
          this.mircoList.push(item)
          this.mircoRepeatCheck.push(item)
        }
      })
      console.log('mircoList:' + this.mircoList)
    },
    enterNextRoadFunc(roadId) {
      let roadName = this.pastRoadNameObj && this.pastRoadNameObj[roadId]
      if (roadName) {
        this.roadName = roadName
        $(this.$refs.roadBar).show()
      } else {
        this.roadName = '未命名道路'
        $(this.$refs.roadBar).show()
      }

      if (this.curCheckRouteType) {
        this.calcRoute(roadId)
      }
      /*if (this.$refs.factory) {
        $(this.$refs.factory).fadeOut(2000, () => {
          this.factoryDetailShow = false;
        });
      }

      this.warnList = [];
      if (this.playTimer) {
        clearTimeout(this.playTimer);
      }
      if (this.$refs.warn) {
        $(this.$refs.warn.$el).fadeOut(2000, () => {
          this.warnDetailShow = false;
        });
      }*/
    },
    renderSingleBubble(latitude, longitude, SN, val, type) {
      DestroyLabelFunc()
      let seriseId = '1'
      if (type === 'cems') {
        seriseId = '3'
      } else if (type === 'tsp') {
        poisType = '2'
      } else if (type === 'vdm') {
        poisType = '2'
      } else if (type === 'pm') {
        poisType = '1'
      }
      let poisType = 'PM10'
      if (type === 'cems') {
        poisType = 'CEMS'
      } else if (type === 'tsp') {
        poisType = 'TSP'
      } else if (type === 'vdm') {
        poisType = 'VDM'
      } else if (type === 'pm') {
        poisType = 'PM10'
      }
      var pm10Obj = {
        dataList: [],
        seriseId: seriseId,
        poisType: poisType,
        callBackFunc: 'poisClick',
        aggregated: 'false'
      }
      if (latitude && longitude) {
        let tmpColor = 0
        if (val < 100) {
          tmpColor = 30
        } else if (val < 200) {
          tmpColor = 60
        } else {
          tmpColor = 100
        }
        pm10Obj.dataList.push({
          lat: latitude,
          lng: longitude,
          id: SN,
          value: val,
          color: tmpColor
        })
      }
      window.bubbleJson = JSON.stringify(pm10Obj)
      LoadLabelFunc(window.bubbleJson)
    },
    async playWarn() {
      let that = this
      this.warnDetailShow = true
      if (this.warnList && this.warnList.length > 0) {
        console.log(this.warnList)
        let equipId = this.warnList.shift()
        let getWorkTicketUrl = CONFIG.requestName + this.$apiOpt.scrollByTime
        let tmpObj = await that.$apiUtils.get(getWorkTicketUrl, {
          customerId: that.$store.state.customerId,
          deviceNoList: equipId
        })

        $(this.$refs.warn).unbind('click')
        $(this.$refs.warn).bind('click', () => {
          this.getWarnTicket([equipId])
        })

        if (!$.isEmptyObject(tmpObj) && !this.factoryDetailShow) {
          this.warnObj = tmpObj
          this.typeId = tmpObj.typeId

          this.$forceUpdate()
          this.$nextTick(() => {
            if (this.$refs.warn) {
              if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
                ChangeFlySpeedFunc(this.slowRate)
              }
              $(this.$refs.warn.$el).fadeIn(1000, function () {
                this.warnDetailShow = true
              })
              $(this.$refs.warn.$el).removeClass('warnLeft')
              $(this.$refs.warn.$el).removeClass('warnRight')
              if (this.factoryPos === 0 && !$.isEmptyObject(tmpObj)) {
                $(this.$refs.warn.$el).addClass('warnRight')
              } else if (this.factoryPos === 1 && !$.isEmptyObject(tmpObj)) {
                $(this.$refs.warn.$el).addClass('warnLeft')
              }
            }
          })

          if (this.playTimer) {
            clearTimeout(this.playTimer)
          }
          this.playTimer = setTimeout(() => {
            if (this.$refs.warn) {
              $(this.$refs.warn.$el).fadeOut(2000, () => {
                this.warnDetailShow = false
                if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
                  ChangeFlySpeedFunc(this.fastRate)
                }
              })
            }
          }, 8000)
        }
      } else {
        if (this.playTimer) {
          clearTimeout(this.playTimer)
        }
        if (this.$refs.warn) {
          $(this.$refs.warn.$el).fadeOut(0, () => {
            this.warnDetailShow = false
            if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
              ChangeFlySpeedFunc(this.fastRate)
            }
          })
        }
      }
    },
    endPathFunc() {
      this.mircoRepeatCheck = []
      this.mircoList = []
      window.roadMeetList = []
    },
    async getEmissionTable() {
      if (this.factoryId) {
        if (ParseRoamFunc) {
          ParseRoamFunc()
        }
        let findDetailedListUrl = CONFIG.requestName + this.$apiOpt.findDetailedList
        let emissionSourceResult = await this.$apiUtils.get(findDetailedListUrl, {
          id: this.factoryId
        })
        this.sourceData = emissionSourceResult
        this.emissionStatus = true
        console.log(this.sourceData)
        this.$forceUpdate()
        this.$nextTick(() => {
          $('.emission_table_vision').show()

          if (this.$refs.factory) {
            if (this.factoryTimer) {
              clearTimeout(this.factoryTimer)
            }
          }
          //$(".emission_table_vision").addClass("emission_show");
        })
      }
    },
    updateDutyInventoryId(val) {
      this.dutyInventoryId = val
    },
    rowClick(row, column, event) {
      let inventoryId = row.id
      let inventoryName = row.emission_source_name

      this.deviceStatus = true
      this.$forceUpdate()
      /*this.updateFactoryArea(this.branchFactoryId, this.emNameVal, true);*/
      this.$nextTick(() => {
        this.updateDutyInventoryId({
          inventoryId: inventoryId,
          inventoryName: inventoryName
        })
      })
      //this.updateDutyInventoryName(inventoryName);
    },
    closePopup() {
      if (this.$store.state.dialogStatus) {
        this.$store.commit('dialogStatus', false)
        if (this.$refs.factory) {
          if (this.factoryTimer) {
            clearTimeout(this.factoryTimer)
          }
          this.factoryTimer = setTimeout(
            () => {
              $(this.$refs.alarm).fadeOut(1000)
              $(this.$refs.factorySub).fadeOut(1000)
              $(this.$refs.factory).fadeOut(1000, () => {
                this.factoryDetailShow = false
                if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
                  ChangeFlySpeedFunc(this.fastRate)
                }
                //CloseWallFunc();
              })
            },
            this.hasNext ? 5000 : 9000
          )
        }

        if (ContinueRoamFunc) {
          ContinueRoamFunc()
        }
      }
    },
    closeEmission() {
      this.emissionStatus = false
      $('.emission_table_vision').hide()
      //$(".emission_table_vision").removeClass("emission_show");

      if (this.$refs.factory) {
        if (this.factoryTimer) {
          clearTimeout(this.factoryTimer)
        }
        this.factoryTimer = setTimeout(
          () => {
            $(this.$refs.alarm).fadeOut(1000)
            $(this.$refs.factorySub).fadeOut(1000)
            $(this.$refs.factory).fadeOut(1000, () => {
              this.factoryDetailShow = false
              if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
                ChangeFlySpeedFunc(this.fastRate)
              }
              //CloseWallFunc();
            })
          },
          this.hasNext ? 5000 : 9000
        )
      }

      if (ContinueRoamFunc) {
        ContinueRoamFunc()
      }
    },
    handleDocumentClick(e) {
      if (!this.emissionStatus || !$('.emission_table_vision').is(':visible') || $('.emission_table_vision').get(0).contains(e.target)) {
      } else {
        let node = e.target && e.target.parentElement && e.target.parentElement.parentElement
        if (node && node.id === 'sampledata') {
          return
        }
        this.closeEmission()
      }

      if (!this.resultWarnTypeId || !$('.warnTicket').is(':visible') || $('.warnTicket').get(0).contains(e.target)) {
      } else {
        this.resultWarnTypeId = ''
        $('.warnTicket').hide()
        //$(".emission_table_vision").removeClass("emission_show");
        if (this.playTimer) {
          clearTimeout(this.playTimer)
        }
        this.playTimer = setTimeout(() => {
          if (this.$refs.warn) {
            $(this.$refs.warn.$el).fadeOut(2000, () => {
              this.warnDetailShow = false
              if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
                ChangeFlySpeedFunc(this.fastRate)
              }
            })
          }
        }, 8000)

        if (ContinueRoamFunc) {
          ContinueRoamFunc()
        }
      }
    },
    async goToPopup() {
      if (ParseRoamFunc) {
        ParseRoamFunc()
      }
      if (this.$refs.factory) {
        if (this.factoryTimer) {
          clearTimeout(this.factoryTimer)
        }
      }
      this.$store.commit('dialogStatus', true)
      this.$popup.open(iframePup, this.dialogCompontent, this, {
        dialog: `${window.bmeConfig.baseUrlHttp}/standard/${
          window.CONFIG.requestName
        }/page/monitor/whole_plant_equip_manage.html?customerId=${this.customerId}&sourceType=1&style=typeDark&branchFactory=${
          this.branchFactory && this.branchFactory.replace(/#/g, '%23')
        }`+(window.bmeConfig.isEnkey ? `&enKey=${getEncryptWithPassword()}` : ''),
        needContinueRoam: true,
        cb: () => {
          console.log(222)
        }
      })
    },
    async initPersonPos() {
      let personArgsUrl = CONFIG.requestName + this.$apiOpt.findUserLatAndLon
      let personArgs = await this.$apiUtils.get(personArgsUrl, {
        customerId: this.customerId
      })
      var Empjson = {
        success: true,
        code: 1,
        msg: '查询成功',
        data: personArgs
      }
      InstantiateEmpTipFunc(Empjson)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query && this.$route.query.setting == 'true') {
      this.hash = true
    } else {
      this.hash = false
    }
    this.curMapType = this.$store.state.mapType

    this.$CamDataTransBack.cb = this.CamDataTransBackFunc
  },
  async beforeUnmount() {
    document.removeEventListener('click', this.handleDocumentClick)
    ShowCarTrailFunc()
    DestroyEmpTipFunc()
    this.reportTypeKey = ''
    if (this.contactRefreshTimer) {
      clearInterval(this.contactRefreshTimer)
    }
    if (this.parseRoamTimer) {
      clearTimeout(this.parseRoamTimer)
    }
    if (this.microTimer) {
      clearTimeout(this.microTimer)
    }
    if (this.cruiseLeapTimer) {
      clearTimeout(this.cruiseLeapTimer)
    }
    if (this.contiueRoamTimer) {
      clearTimeout(this.contiueRoamTimer)
    }
    this.endPathFunc()
    if ($(this.$refs.mathRoad_container).length > 0) {
      $(this.$refs.mathRoad_container).hide()
    }
    await this.agoraRTC_LEAVE('', true)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    HideCarTrailFunc()
    this.reportTypeKey = 'auto'
    this.allFactoryList = [
      {
        latitude: '39.499889',
        name: '3#高炉矿槽',
        id: 2,
        type: 'factory',
        longitude: '118.272522'
      },
      {
        latitude: '39.500001',
        name: '4#高炉矿槽',
        id: 3,
        type: 'factory',
        longitude: '118.27422'
      },
      {
        latitude: '39.499685',
        name: '2#高炉矿槽',
        id: 4,
        type: 'factory',
        longitude: '118.270222'
      },
      {
        latitude: '39.504705',
        name: '1#烧结车间',
        id: 5,
        type: 'factory',
        longitude: '118.267054'
      },
      {
        latitude: '39.500434',
        name: '2#烧结车间',
        id: 6,
        type: 'factory',
        longitude: '118.271153'
      },
      {
        latitude: '39.500554',
        name: '3#烧结车间',
        id: 7,
        type: 'factory',
        longitude: '118.273083'
      },
      {
        latitude: '39.500643',
        name: '4#烧结车间',
        id: 8,
        type: 'factory',
        longitude: '118.274177'
      },
      {
        latitude: '39.504544',
        name: '第一炼钢',
        id: 9,
        type: 'factory',
        longitude: '118.268929'
      },
      {
        latitude: '39.500315',
        name: '二炼钢',
        id: 10,
        type: 'factory',
        longitude: '118.276532'
      },
      {
        latitude: '39.501457',
        name: '钢渣处理',
        id: 11,
        type: 'factory',
        longitude: '118.266257'
      },
      {
        latitude: '39.500828',
        name: '白灰料棚',
        id: 12,
        type: 'factory',
        longitude: '118.27612'
      },
      {
        latitude: '39.50326',
        name: '白灰车间',
        id: 13,
        type: 'factory',
        longitude: '118.274953'
      },
      {
        latitude: '39.5026749963',
        name: '1#高炉矿槽',
        id: 14,
        type: 'factory',
        longitude: '118.2663220862'
      },
      {
        latitude: '39.504673',
        name: '1#高炉',
        id: 15,
        type: 'factory',
        longitude: '118.270708'
      },
      {
        latitude: '39.498036',
        name: '2#高炉',
        id: 16,
        type: 'factory',
        longitude: '118.271828'
      },
      {
        latitude: '39.498258',
        name: '3#高炉',
        id: 17,
        type: 'factory',
        longitude: '118.27344'
      },
      {
        latitude: '39.49843',
        name: '4#高炉',
        id: 18,
        type: 'factory',
        longitude: '118.275221'
      },
      {
        latitude: '39.505136',
        name: '1580mm轧线',
        id: 19,
        type: 'factory',
        longitude: '118.276971'
      },
      {
        latitude: '39.496348',
        name: '950mm轧线',
        id: 20,
        type: 'factory',
        longitude: '118.2818'
      },
      {
        latitude: '39.494328',
        name: '850mm轧线',
        id: 21,
        type: 'factory',
        longitude: '118.277064'
      },
      {
        latitude: '39.498131',
        name: '块矿料棚',
        id: 23,
        type: 'factory',
        longitude: '118.270001'
      },
      {
        latitude: '39.504326',
        name: '智控中心',
        id: 27,
        type: 'factory',
        longitude: '118.276144'
      },
      {
        latitude: '39.498147',
        name: '能管中心',
        id: 28,
        type: 'factory',
        longitude: '118.276713'
      },
      {
        latitude: '39.504254',
        name: '100MW锅炉发电',
        id: 30,
        type: 'factory',
        longitude: '118.28111'
      },
      {
        latitude: '39.503179',
        name: '12立方米煤气柜',
        id: 40,
        type: 'factory',
        longitude: '118.267192'
      },
      {
        latitude: '39.502831',
        name: '烧结配料',
        id: 43,
        type: 'factory',
        longitude: '118.272976'
      },
      {
        latitude: '39.501978',
        name: '2#3#4#烧结预配料',
        id: 44,
        type: 'factory',
        longitude: '118.268682'
      }
    ]
    this.agoraStatus = bmeConfig.needRTCandRTM ? bmeConfig.needRTCandRTM : false
    if (this.agoraStatus) {
      this.initPersonPos()
      /*this.reportListShow = true;
      this.$forceUpdate();
      this.getWorkTicketReport();*/
      this.INIT_RTM_RTC()
      this.startBasicCall()

      this.voiceIconAnimate()

      this.initContactData()
      this.initSpecialContactData()
      this.initContactList()
      if (this.contactRefreshTimer) {
        clearInterval(this.contactRefreshTimer)
      }
      this.contactRefreshTimer = setInterval(() => {
        //this.contactOnline = true;
        this.initContactData()
        this.initSpecialContactData()
      }, 30000)

      if (this.translateTimer) {
        clearInterval(this.translateTimer)
      }
      this.translateTimer = setInterval(() => {
        this.getTranslateData()
      }, 500)
      if (this.microTimer) {
        clearInterval(this.microTimer)
      }

      this.getMicroStatus()
      /*this.microTimer = setInterval(() => {
        this.getMicroStatus();
      }, 500);*/

      this.findWorkTicketHistoryFunc()
      if (this.workTicketTimer) {
        clearInterval(this.workTicketTimer)
      }
      this.workTicketTimer = setInterval(() => {
        this.findWorkTicketHistoryFunc()
      }, 60000)
    }

    document.addEventListener('click', this.handleDocumentClick)

    if (bmeConfig.slowRate) {
      this.slowRate = bmeConfig.slowRate
    }

    if (bmeConfig.fastRate) {
      this.fastRate = bmeConfig.fastRate
    }

    if (bmeConfig.showFactoryPoint) {
      this.showFactoryPoint = bmeConfig.showFactoryPoint
    }

    if (bmeConfig.autoVisionTime) {
      this.unity3DTime = bmeConfig.autoVisionTime
    }

    if (bmeConfig.mapType === 'unity3D') {
      setTimeout(() => {
        this.dateTimeChange()
      }, 500)
    }

    setTimeout(() => {
      if (this.showFactoryPoint) {
        OpenPointsMeshFunc()
      } else {
        ClosePointsMeshFunc()
      }
    }, 500)

    this.showMiniMap = bmeConfig.showMiniMap
    if (this.showMiniMap) {
      setTimeout(() => {
        ShowGlobalMapFunc()
      }, 500)
    }

    $(this.$refs.roadBar).hide()

    setTimeout(() => {
      $(this.$refs.roadBar).show()
    }, 5000)

    this.curBG = this.$store.state.curBG

    this.pastRoadNameObj = bmeConfig.pastRoadNameList

    this.$roadVisionFunc.cb = this.roadVisionFunc
    this.$roadVisionEquipFunc.cb = this.roadPushStack
    this.$endPathFunc.cb = this.endPathFunc

    this.$enterNextRoadFunc.cb = this.enterNextRoadFunc

    this.getTspData()

    this.getVdmData()

    this.getPM10Data()

    $('.emission_table_vision').hide()

    this.mircoTimer = setInterval(() => {
      this.roadVisionEquipFunc()
    }, 1000)
    /*this.roadVisionEquipFunc();
    this.factoryDetailShow = true;
    this.warnDetailShow = true;
    $(this.$refs.factory).fadeOut(50);
    $(this.$refs.factory).fadeIn(5000);
    */
    //this.factoryDetailShow = true;

    if (HideHeatLineFunc) {
      setTimeout(() => {
        HideHeatLineFunc()
        SetMapAlphaFunc(this.opacityVal)
      }, 500)
    }

    $(this.$refs.factory).hide()
    $(this.$refs.factorySub).hide()
    $(this.$refs.alarm).hide()
    //this.roadVisionFunc([{ id: "24", location: 0 }]);
    if (ChangeFlySpeedFunc && this.getRemoteContactWin() === 0) {
      ChangeFlySpeedFunc(this.fastRate)
    }

    if (bmeConfig.miniMapHeight && bmeConfig.miniMapWidth) {
      $(this.$refs.miniMapBar).css('height', bmeConfig.miniMapHeight + 'px')
      $(this.$refs.miniMapBar).css('width', bmeConfig.miniMapWidth + 'px')
    }

    if (bmeConfig.miniMapTop && bmeConfig.miniMapRight) {
      $(this.$refs.miniMapBar).css('top', bmeConfig.miniMapTop + 'px')
      $(this.$refs.miniMapBar).css('right', bmeConfig.miniMapRight + 'px')
    }

    //打开巡查报告
    // this.$store.commit("changeEmissionSwitch", "openReport");

    //自定义audio转wav
    //请求麦克风
  },
  activated() {},
  deactivated() {},
  beforeRouteLeave() {
    if (this.contactRefreshTimer) {
      clearInterval(this.contactRefreshTimer)
    }
    if (this.parseRoamTimer) {
      clearTimeout(this.parseRoamTimer)
    }
    if (this.microTimer) {
      clearTimeout(this.microTimer)
    }
    if (this.cruiseLeapTimer) {
      clearTimeout(this.cruiseLeapTimer)
    }
    if (this.contiueRoamTimer) {
      clearTimeout(this.contiueRoamTimer)
    }
    if (ExitCruiseFunc) {
      ExitCruiseFunc()
      //window.autoVison = false;
    }
    if (HideMinimapFunc) {
      HideMinimapFunc()
    }
    if (HideGlobalMapFunc) {
      HideGlobalMapFunc()
    }

    if (bmeConfig.initTime) {
      this.unity3DTime = bmeConfig.initTime
    }

    if (this.translateTimer) {
      clearInterval(this.translateTimer)
    }
    if (this.microTimer) {
      clearTimeout(this.microTimer)
    }

    if (bmeConfig.mapType === 'unity3D') {
      setTimeout(() => {
        this.dateTimeChange()
      }, 500)
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == 'true') {
      this.hash = true
    } else {
      this.hash = false
    }
    this.reload()
  }
}
</script>

<style lang="scss">
.agoraRTC-localVideoBar {
  position: absolute;
  height: 320px;
  width: 420px;
  top: 120px;
  right: 50px;
  z-index: 10000;
}

@keyframes neon3 {
  from {
    text-shadow: 0 0 5px #ffffff40, 0 0 10px #ffffff40, 0 0 15px #ffffff40, 0 0 20px #30d59440, 0 0 35px #30d59440, 0 0 40px #30d59440,
      0 0 50px #30d59440, 0 0 75px #30d59440;
  }
  to {
    text-shadow: 0 0 5px #ffffff40, 0 0 5px #ffffff40, 0 0 7px #ffffff40, 0 0 10px #30d59440, 0 0 17px #30d59440, 0 0 20px #30d59440,
      0 0 25px #30d59440, 0 0 37px #30d59440;
  }
}

.isOnLine {
  animation: neon3 1.5s ease-in-out infinite alternate;
  position: absolute;
  right: 35px;
  color: #6dd400;
  font-size: 14px;
  margin: 3px 6px;
}

.notOnLine {
  //animation: neon3 1.5s ease-in-out infinite alternate;
  position: absolute;
  right: 35px;
  color: #ddd;
  font-size: 14px;
  margin: 3px 6px;
}

.agoraRTC-remoteVideoBar {
  position: absolute;
  height: 600px;
  width: 800px;
  top: 240px;
  left: 1520px;
  z-index: 10000;
}

.contact-bar {
  background-image: url('img/contactBar.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 800px;
  height: 600px;
  padding: 20px;
  border-radius: 30px;
  overflow: hidden;
  position: absolute;

  .playerContainerBtn {
    background-image: url('img/endContact.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 346px;
    height: 66px;
    bottom: 50px;
    position: absolute;
    left: 230px;
    z-index: 999;
    pointer-events: all;
  }
}

.contact-bar > div {
  border-radius: 50px;
}

.Microphone-bar {
  width: 120px;
  height: 120px;
  position: absolute;
  transform: scale(0.8);
  bottom: 115px;
  left: 2%;
  z-index: 999;
  pointer-events: all;
  width: 800px;
  height: 160px;
  background: rgba(0, 0, 0, 0.09);
  border-radius: 16px;
  border: 2px solid #def6ff;
  .headIcon-bar {
    position: absolute;
    border-radius: 20px;
    height: 156px;
    width: 195px;
    top: 0px;
    left: 0px;
    border: 1px solid #fff;
    .headIcon {
      position: absolute;
      width: 140px;
      top: 15px;
      left: 35px;
    }
  }

  #Microphone {
    pointer-events: none;
  }
  .order-content {
    position: absolute;
    width: 560px;
    height: 140px;
    //background: rgba(255, 0, 0, 0.4);
    left: 230px;
    top: 10px;
    .hide {
      opacity: 0;
    }
    .name {
      font-size: 34px;
      color: #fff;
    }
    .content {
      font-size: 26px;
      color: #f4c48f;
    }
    .o_txt {
      background: none;
      border: none;
      font-size: 36px;
      margin-top: 6px;
    }
  }
  .voluemImg {
    background: url(img/microphone.png) no-repeat center center;
    display: block;
    /* margin: 31px auto; */
    width: 36px;
    height: 58px;
    width: 218px;
    height: 160px;
    position: absolute;
    top: -3px;
    left: -23px;
  }
}
.contact_show_btn {
  position: absolute;
  top: 170px;
  left: 15px;
  pointer-events: all;
  cursor: pointer;
}
.call_bar {
  border-radius: 16px;
  overflow: hidden;
  position: absolute;
  background-image: url(img/call_outer.png);
  background-repeat: no-repeat;
  background-size: 500px 550px;
  background-position: -50px -25px;
  top: 290px;
  left: 1740px;
  z-index: 10001;
  height: 510px;
  width: 400px;
  .call_bar_bg {
    border-radius: 16px;
    overflow: hidden;
    position: absolute;
    top: 160px;
    left: 110px;
    background: url(img/phone-icon_.png) no-repeat center center;
    height: 160px;
    width: 160px;
    background-size: 100% 100%;
    opacity: 0.7;
    background-repeat: no-repeat;
  }
  .call_name {
    position: absolute;
    width: 350px;
    top: 50px;
    left: 20px;
    text-align: center;
    font-size: 28px;
  }
  .call_icon {
    position: absolute;
    top: 400px;
    left: 85px;
    background: url(img/call_icon.png) no-repeat center center;
    height: 60px;
    width: 220px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    cursor: pointer;
    pointer-events: all;
    .call_txt {
      position: absolute;
      top: 10px;
      font-size: 26px;
      right: 50px;
      pointer-events: all;
    }
  }
}
.contactList,
.specialContactList {
  position: absolute;

  top: 250px;
  overflow: hidden;
  left: 2750px;
  height: 630px;
  width: 456px;
  z-index: 999;
  border-radius: 16px;
  background-image: url(img/phone-book.png);
  background-size: 500px 685px;
  background-position-x: -22px;
  background-position-y: -20px;
  background-repeat: no-repeat;
  pointer-events: all;
  .slide-up,
  .slide-down {
    display: none;
  }
  .slider-nav {
    background: #1f3a56 !important;
  }
  .contactType_title {
    padding: 0px 15px;
    font-size: 20px;
    line-height: 50px;
    height: 50px;
    color: #e2effd;
  }
  .switch-bar {
    position: absolute;
    top: 15px;
    right: 88px;
    width: 80px;
    img {
      display: inline-block !important;
      margin-left: 50px !important;
    }
  }
  .closeContact {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 56px;
    height: 30px;
    background-image: url(/static/img/popupImg/closeBtn.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .slider-content {
    min-height: 580px !important;
    overflow-x: hidden !important;
    .title {
      padding: 2px 0;
      text-indent: 10px;
      background: #01102e;
      padding: 10px 5px;
      /* background: #bbb; */
      /* border-radius: 16px; */
      /* border: 1px solid; */
      /* border-image: linear-gradient(180deg, rgba(224, 32, 32, 1), rgba(250, 100, 0, 1), rgba(247, 181, 0, 1), rgba(109, 212, 0, 1), rgba(0, 145, 255, 1), rgba(98, 54, 255, 1), rgba(182, 32, 224, 1)) 1 1; */
      //background: #195fa9;
      color: #dcdfe6;
      width: 100%;
      float: left;
      font-size: 20px;
      //font-weight: bold;
      text-transform: uppercase;
      font-family: 'normalFont';
    }
    ul ul li {
      a {
        height: 70px;
        .person-icon {
          width: 55px;
          height: 55px;
          top: 8px;
          position: relative;
          display: inline-block;
        }
        .person-phone {
          width: 30px;
          height: 32px;
          top: 8px;
          position: relative;
          display: inline-block;
          left: 320px;
          font-family: 'normalFont';
        }
        .person-pos {
          color: #ffffff;
          position: absolute;
          margin-top: 40px;
          left: 80px;
          font-size: 18px;
        }
        .person-posVal {
          color: #ffffff;
          //font-weight: bolder;
          position: absolute;
          margin-top: 42px;
          left: 135px;
          font-size: 16px;
        }
        .person-name {
          color: #b5d7ff;
          position: absolute;
          display: inline-block;
          margin: 3px 5px 5px 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 190px;
          word-break: break-all;
          white-space: nowrap;
          font-size: 18px;
        }
        padding: 5px 10px;
        display: block;
        border-bottom: 1px solid #ffffff40;
        text-transform: capitalize;
        font-size: 22px;
        color: #4a90e2;
      }
    }
  }
  .slider-nav {
    top: 55px !important;
    min-height: 580px !important;
  }
}

.contactList {
  top: 150px !important;
  left: 50px !important;
  background-image: url(img/phone-book1.png) !important;
  background-size: 500px 685px !important;
  background-position-x: -22px !important;
  background-position-y: -20px !important;
  background-repeat: no-repeat !important;

  .contactType_title {
    background: #0c202f !important;
  }
}

/*底部*/
.send {
  width: 500px;
  height: 36px;
  position: absolute;
  bottom: 150px;
  left: 5%;
  z-index: 999;
  pointer-events: all;
  //display: none;
}
.send .s_fiter {
  width: 100%;
  height: 100%;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 18px;
  /*opacity: 0.8;*/
  /*filter: alpha(opacity=80);*/
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.send .s_con {
  width: 100%;
  height: 28px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  text-align: center;
  line-height: 1.15rem;
}
.send .s_txt {
  /*//  float:left;*/
  font-size: 14px;
  width: 70%;
  height: 28px;
  /*//  border-radius: 0.1rem 0 0 0.1rem;*/
  outline: none;
  border: none;
  /*//  margin-top:15px;*/
  margin-left: 40px;
}
.send .s_sub {
  /*//  float:right;
//  margin-top:15px;*/
  margin-right: 3px;
  display: inline-block;
  width: 30px;
  height: 30px;
  background: url(img/ok.png) no-repeat;
  background-size: 100% 100%;
}

.taste-button {
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 999;
  pointer-events: all;
}
.taste-button_ {
  position: absolute;
  bottom: 0px;
  left: 300px;
  z-index: 999;
  pointer-events: all;
}
.emission_table_vision {
  left: calc(50% + 90px) !important;
  top: 270px;
  width: 650px;
  position: absolute;
  pointer-events: all;
  display: none;
  z-index: 999;
  //opacity: 0;
  background: linear-gradient(269deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6) 40%, black) !important;
  .source_table {
    border: 1px solid #84aaff40 !important;
    background: #01132d40 !important;
  }
  .thClass {
    background: #01122ba6 !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass > .cell {
    font-size: 16px !important;
    color: #47ffddff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
  }

  .thClass_ {
    background: #01122ba6 !important;
    border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass_ > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
  }

  .tdClass {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
  }
  .tdClass > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .tdClass_ {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #0b336b40 !important;
  }

  .tdClass_ > .cell > div {
    font-size: 16px !important;
    color: #888888ff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .headTrClass {
    border: 1px solid rgba(132, 170, 255, 0.5) !important;
  }
}

.mini_map {
  position: absolute;
  width: 751px;
  height: 664px;
  right: 60px;
  bottom: calc(50% - 325px);
  background-image: url(img/miniMap.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.mini_map_new {
  position: absolute;
  top: 105px;
  right: 0px;
  width: 382px;
  height: 459px;
  background-image: url(img/mapBar.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  a {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 72px;
    font-size: 28px;
    font-family: 'fontNormal';
    color: #fff;
    text-align: center;
    pointer-events: all;
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.33) 30%, transparent);
    padding: 10px 20px;
    border: 1px solid #333;
    border-radius: 10px;
    cursor: pointer;
  }
}

.big_map {
  position: absolute;
  display: block;
  top: 214px;
  left: 90px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.small_map {
  position: absolute;
  display: block;
  top: 366px;
  left: 90px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.opacity_20 {
  position: absolute;
  display: block;
  top: 445px;
  left: 555px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.opacity_40 {
  position: absolute;
  display: block;
  top: 368px;
  left: 600px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.opacity_60 {
  position: absolute;
  display: block;
  top: 290px;
  left: 645px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.opacity_80 {
  position: absolute;
  display: block;
  top: 212px;
  left: 600px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.opacity_100 {
  position: absolute;
  display: block;
  top: 134px;
  left: 555px;
  width: 72px;
  font-size: 28px;
  font-family: 'fontNormal';
  color: #fff;
  text-align: center;
  line-height: 85px;
  pointer-events: all;
}

.mapTypeSel {
  background-image: url(img/miniMapSel.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.emission_show {
  -webkit-animation: emissionShow 0.5s linear;
  animation: emissionShow 0.5s linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@keyframes emissionShow {
  0% {
    opacity: 0px;
  }
  100% {
    opacity: 100%;
  }
}

.phoneCall_animate {
  -webkit-animation: phoneCall 0.5s linear;
  animation: phoneCall 0.5s linear;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@keyframes phoneCall {
  0% {
    transform: rotateZ(5deg);
  }
  100% {
    transform: rotateZ(-5deg);
  }
}
</style>

<style lang="scss">
.specialReport {
  .report-bar {
    background-image: url(img/report-bar_.png) !important;
  }
  .swiper-slide-bar {
    background-image: url(img/report-bar_.png) !important;
  }

  .swiper-slide-bar_ {
    background: none !important;
  }
  .swiper-wrapper {
    .swiper-slide {
      background-image: url(img/round-bg.png) !important;
      background-repeat: no-repeat !important;
      background-size: 100% 100% !important;
      background-origin: center center !important;
      border: none !important;
      margin-bottom: 5px !important;

      .popup-type1-idx {
        margin-right: 0px !important;
        margin-left: 20px !important;
      }
    }
  }
}
.reportList {
  width: 100% !important;
  z-index: 99;
  padding-top: 185px;
  .reportRouteSetting {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 30px;
    margin-left: 30px;
    background-image: url(img/edit.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .reportTitle {
    color: #fff !important;
    font-size: 26px;
    display: block !important;
    line-height: 28px !important;
    span {
      color: #2febff;
      font-family: 'number';
      text-decoration: underline;
      text-underline-position: under;
      font-size: 20px;
      margin: 0 10px;
    }
  }
  .reportContent {
    color: #2febff;
    font-family: 'number';
    text-decoration: underline;
    text-underline-position: under;
    font-size: 20px;
    margin: 0 10px;
  }
  .moreReport {
    color: #2febff;
    font-size: 20px;
    text-decoration: underline !important;
    text-underline-position: under;
    margin: 0 20px 0 10px;
    cursor: pointer;
  }
  .closeReport {
    background: url(/static/img/popupImg/closeBtn.png);
    position: absolute;
    right: 5px;
    top: 5px;
    width: 67px;
    background-repeat: no-repeat;
    height: 42px;
    cursor: pointer;
    pointer-events: all;
  }
  .return-btn {
    background-image: url(/static/img/return.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 120px;
    height: 40px;
    position: absolute;
    top: 35px;
    right: 36px;
    z-index: 1;
    cursor: pointer;
  }

  .reportAddress {
    margin: auto;
    height: 744px;
    font-size: 22px;
    top: 186px;
    width: 500px;
    padding: 45px 50px;
    transform: scale(1.1);
    position: absolute;
    right: 1105px;
    pointer-events: all;
    /* background: rgba(0, 0, 0, 0.6); */
    background: url(img/report-bar.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .swiper-container::-webkit-scrollbar-thumb {
      background-color: #21a6e4 !important;
    }
    .swiper-container::-webkit-scrollbar {
      width: 10px !important;
    }
    .swiper-slide-bar {
      position: absolute;
      top: 85px;
      left: 15px;
      /*width: 365px;*/
      background: none !important;
      height: 580px !important;
      overflow: hidden;
      /*.swiper-slide {
        height: 40px !important;
      }*/
    }
    .moreEmissionBtn {
      position: absolute;
      right: -35px;
      top: 92px;
      font-size: 20px;
      color: #fbd4a2;
      font-weight: bolder;
      cursor: pointer;
    }
    .famous_school_item_swiper {
      height: 580px !important;
      .swiper-container {
        overflow-y: scroll !important;
        overflow-x: hidden;
      }
      .swiper-wrapper {
        flex-direction: column !important;
      }
      .swiper-slide {
        height: 160px !important;
      }
    }
  }
  .report-bar {
    margin: auto;
    height: 750px;
    top: 180px;
    width: 570px;
    padding: 45px 50px;
    transform: scale(1.1);
    position: absolute;
    right: 550px;
    pointer-events: all;
    /* background: rgba(0, 0, 0, 0.6);*/
    background: url(img/report-bar.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .swiper-slide-bar_ {
      top: 245px;
      width: 470px;
      position: absolute;
      bottom: 45px;
      /* background: rgba(0, 0, 0, 0.6);*/
      background: #01122b;
    }

    .famous_school_item_slide {
      font-size: 18px;
      padding: 0px 20px;
      line-height: 24px !important;
    }
    .famous_school_item_swiper {
      //height: 780px !important;
      position: relative !important;
      padding: 25px 5px 15px 10px !important;
    }
  }
  .reportHistory {
    .famous_school_item_slide {
      border-top: 1.5px solid #98f4f4;
      border-bottom: 1.5px solid #98f4f4;
      margin: 15px 0;
      padding: 10px 0;
      background: #01152b;
    }
  }
  .swiper-slide-bar {
    /*width: 255px;*/
    pointer-events: all;
    margin: auto;
    height: 750px;
    top: 180px;
    width: 470px;
    padding: 0 50px;
    transform: scale(1.1);
    position: absolute;
    right: 550px;
    /* background: rgba(0, 0, 0, 0.6);*/
    background: url(img/report-bar.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .famous_school_item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .famous_school_item_inner {
    width: 100%;
  }
  .famous_school_item_top {
    width: 100%;
    height: 57px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .famous_school_item_top h3 {
    color: rgba(255, 255, 255, 0.8);
    border-left: 4px solid #ffffff;
    font-size: 14px;
    line-height: 16px;
    padding-left: 5px;
  }
  .famous_school_item_swiper {
    width: 100%;
    /*height: 290px;*/
    height: 710px;
    padding: 45px 5px 10px 10px;
    box-sizing: border-box;
    //background-color: #ffffff;
    border-radius: 0px 0px 0px 20px;
    overflow: hidden;
  }
  .famous_school_item_swiper.active {
    overflow-y: scroll;
  }
  .famous_school_item_swiper .swiper-container {
    height: 100%;
  }
  .famous_school_item_swiper .swiper-wrapper {
    -webkit-transition-timing-function: linear; /*之前是ease-out*/
    -moz-transition-timing-function: linear;
    -ms-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
  }
  .empty-warn {
    width: 200px;
    height: 180px;
    margin: 80px auto;
  }
  .empty-warn-font {
    text-align: center;
    position: relative;
    margin-top: -50px;
  }
  .famous_school_item_swiper .swiper-slide {
    width: 100%;
    /*margin-bottom: 5px;*/
    /*border-bottom: 1px solid rgba(132, 170, 255, 0.5);*/
    /*border-left: 1px solid rgba(132, 170, 255, 0.5);
    border-right: 1px solid rgba(132, 170, 255, 0.5);*/
    height: 145px !important;
    overflow: hidden;
  }
  .famous_school_item_list {
    width: 100%;
    height: 260px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .famous_school_item_slide {
    color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    /* margin-bottom: 15px; */
  }
  .famous_school_item_num {
    width: 20px;
    margin-right: 10px;
    font-weight: bold;
    font-size: 14px;
  }
  .famous_school_item_info {
    overflow: hidden;
  }
  .famous_school_item_info h4 {
    font-size: 14px;
  }
  .famous_school_item_info p {
    color: rgba(0, 0, 0, 0.6);
    letter-spacing: 0;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .famous_school_item_infos {
    height: 134px;
    background: #ffffff;
    border-radius: 20px 0px 0px 20px;
    padding: 10px;
    color: #000000;
    font-size: 10px;
    margin-top: 10px;
  }
  .swiper-pagination {
    width: 100%;
    position: initial;
    display: none;
    justify-content: center;
    margin-top: 15px;
  }
  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
    background-color: #e6e6e6;
    opacity: 1;
    margin: 0 2px;
  }
  .swiper-pagination-bullet-active {
    background-color: #d5286e;
    opacity: 1;
  }
}
.call_in {
  position: absolute;
  width: 377px;
  height: 97px;
  top: 130px;
  left: 50px;
  background-image: url('./img/call_in.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 5px 15px;
}
.call_in_name {
  line-height: 87px;
  font-size: 26px;
  float: left;
  width: 220px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: normal;
  white-space: nowrap;
}
.call_in_get {
  height: 50px;
  width: 50px;
  margin-top: 18px;
  margin-right: 10px;
  vertical-align: middle;
  float: right;
  background-image: url('./img/call_in_get.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  pointer-events: all;
}
.call_in_down {
  height: 50px;
  width: 50px;
  margin-top: 18px;
  vertical-align: middle;
  float: right;
  background-image: url('./img/call_in_down.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  pointer-events: all;
}
</style>

<style lang="scss" scoped>
.endWorkTicket-btn {
  font-size: 32px;
  padding: 12px 30px;
  margin-top: 30px;
  margin-left: 50px;
  border-radius: 10px;
  background: rgba(1, 21, 43, 0.8);
  border: 0.76px solid #2672b9;
  display: inline-block;
  cursor: pointer;
  position: absolute;
  bottom: 150px;
  right: 115px;
  pointer-events: all;
}
.reportList {
  .emissionReportBrief {
    font-size: 22px;
    span {
      font-size: 22px;
    }
  }
  .popup-type1-idx {
    display: inline-block;
    font-size: 32px;
    font-family: 'number';
    margin-right: 20px;
  }
  .warn1_title {
    width: 580px !important;
    display: block !important;
    height: 155px !important;
  }

  .popup-type1-time {
    color: #fff !important;
    font-size: 18px !important;
    margin-top: 5px !important;
    width: 150px !important;
  }

  .popup-type2-time {
    color: #fff !important;
    font-size: 18px !important;
    margin-top: 5px !important;
    width: 150px !important;
  }

  .warn1_box {
    width: 400px !important;
  }

  .warn1_treatmentBox {
    /*width: 400px !important;*/
    background: none !important;
    box-shadow: none !important;
    line-height: 30px;
    .person-phone {
      display: block;
      margin: 10px auto;
    }
  }
}

.report,
.reportList {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;

  /*background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.85), transparent);*/

  .sliderReport {
    transform: scale(1.4);
    transform-origin: top center;
  }

  .warn1_title {
    display: flex;
    align-items: flex-end;
    border-bottom: 0px solid;
    border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
    justify-content: space-between;
    padding: 5px 15px;
    .popup-type1-title {
      font-size: 18px;
      font-family: 'normalFont';
      color: #4be0ff;
      line-height: 24px;
      display: flex;
      align-items: center;
      // flex-wrap: nowrap;
      overflow: hidden;
      flex: 1;
      text-align: left;
      /*&::before {
        content: "";
        display: block;
        width: 7px;
        height: 7px;
        background: #ff7373;
        box-shadow: 0px 0px 7px 0px #df3131;
        border: 1px solid #da3636;
        border-radius: 50%;
        display: inline-block;
        margin-right: 16px;
      }*/
    }
    .popup-type1-title_green {
      color: #b5d7ff !important;
      &::before {
        background: #dffff3 !important;
        box-shadow: 0px 0px 7px 0px rgba(48, 213, 148, 0.81) !important;
        border: 1px solid #30d594 !important;
      }
    }
    .popup-type1-time {
      // height: 14px;
      padding-bottom: 5px;
      font-size: 16px;
      font-family: 'number';
      font-weight: bolder;
      color: #ffffff;
      line-height: 14px;
      width: 90px;
      display: block;
    }
  }

  .warn1_content {
    margin-top: 20px;
    padding: 0 20px;
    .warn1_state {
      height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      margin-bottom: 15px;
      text-align: left;
      span {
        color: #f4c48f;
        font-weight: 500;
      }
    }
    .warn1_road_info {
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 30px;
      text-align: left;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .warn1_position {
      //height: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #94a2b0;
      line-height: 18px;
      text-align: left;
      span {
        color: #4fc5ff;
        font-weight: 500;
      }
    }
    .new-chart-style {
      margin-bottom: 10px;
    }
  }

  .warn1_box {
    margin-top: 5px;
    width: 100%;
    height: 126px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
    padding: 13px 79px;
    transform: scale(0.85);
    transform-origin: center;

    .smallBox {
      @include bg-box(100%, 100px, 'warn1_bg.png');
      text-align: center;
      padding-top: 10px;
      .warn1_type_name {
        height: 16px;
        font-size: 16px;
        color: #99f5ff;
        line-height: 16px;
        margin-bottom: 15px;
      }
      .warn1_type_num {
        height: 32px;
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        margin-bottom: 5px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.32);
      }
      .warn1_type_unit {
        height: 12px;
        font-size: 12px;
        color: #aaaaaa;
        line-height: 12px;
        text-shadow: 2px 2px 2px rgba(255, 255, 255, 0.3);
      }
    }
  }

  .warn1_treatmentBox {
    /*margin-top: -18px;*/
    height: 126px;
    background: rgba(0, 0, 0, 0.42);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.66);
    font-size: 16px;
    text-align: left;
    .warn1_treatment {
      text-align: center;
      width: 80px;
      font-size: 16px;
      /* background: #068acb; */
      border-radius: 4px;
      /* line-height: 100px; */
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 20px;
      margin: 2px 5px;
      padding: 1px 2px;
      font-family: 'fontNormal';
      position: relative;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.mathRoad_container {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.father_bar {
  -webkit-perspective: 1000px;
  -moz-perspective: 1000px;
  perspective: 1000px;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.bg_container {
  position: absolute;
  width: 90% !important;
  margin: 0 3% !important;
  height: 80% !important;
  margin-top: 3% !important;
}

.factory_bar {
  position: absolute;
  /*background: linear-gradient(271deg, rgb(0 0 0 / 50%), rgb(1 19 45 / 50%));*/
  /*background-image: url("/static/img/factoryBar.png");*/
  background-image: url('img/3.png');
  background-size: 100% 100%;
  transform: translate3d(100px, 100px, 100px);
  width: 600px;
  height: 480px;
  font-weight: bolder;
  padding: 125px 35px 8px 50px;
  font-size: 22px;
  font-family: 'fontNormal';
  pointer-events: all;
}

.nearly_person {
  position: absolute;
  background-size: 100% 100%;
  transform: translate3d(0px, 0px, 90px) rotateY(-75deg) rotateX(0deg);
  right: 1250px;
  top: 630px;
  width: 440px;
  height: 75px;
  font-weight: bolder;
  line-height: 75px;
  font-size: 34px;
  text-align: center;
  font-family: 'fontNormal';
  pointer-events: all;
  color: #ffec03;
  text-shadow: 10px 10px 10px black;
  div {
    padding-right: 260px;
    text-align: right;
    color: #ffec03;
    width: 700px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    word-break: normal;
  }
  //background: linear-gradient(90deg, #00000047, #00000082, #00000047);
}

.nearly_car {
  position: absolute;
  background-size: 100% 100%;
  transform: translate3d(0px, 0px, 90px) rotateY(-75deg) rotateX(0deg);
  right: 1250px;
  top: 710px;
  width: 440px;
  height: 75px;
  font-weight: bolder;
  line-height: 75px;
  font-size: 34px;
  text-align: center;
  font-family: 'fontNormal';
  pointer-events: all;
  color: #ffec03;
  text-shadow: 10px 10px 10px black;
  div {
    padding-right: 160px;
    text-align: right;
    color: #ffec03;
    width: 600px;
  }
}

.road_bar {
  position: absolute;
  background-size: 100% 100%;
  transform: translate3d(0px, 0px, 90px) rotateY(-75deg) rotateX(0deg);
  right: 1200px;
  top: 440px;
  width: 553px;
  height: 228px;
  font-weight: bolder;
  text-align: center;
  line-height: 228px;
  font-size: 22px;
  font-family: 'fontNormal';
  pointer-events: all;

  .road_bar_bg {
    position: absolute;
    background-image: url('img/road.png');
    background-size: 100% 100%;
    left: 0px;
    top: 0px;
    width: 553px;
    height: 228px;
    opacity: 0.85;
  }
  .road_name {
    position: absolute;
    left: 30px;
    top: 0px;
    width: 553px;
    height: 228px;
    font-size: 48px;
    font-family: 'fontNormal';
    font-weight: bold;
    color: #ffff00;
    letter-spacing: 15px;
  }
}

.nobulding {
  background-image: url('img/4.png');
  background-size: 100% 100%;
  transform: translate3d(100px, 100px, 100px);
}

.factorySub_bar {
  position: absolute;
  /*background: linear-gradient(271deg, rgb(0 0 0 / 50%), rgb(1 19 45 / 50%));*/
  /*background-image: url("/static/img/factoryBar.png");*/
  background-size: 100% 100%;
  transform: translate3d(100px, 100px, 100px);
  width: 550px;
  font-weight: bolder;
  /*padding: 80px 70px 8px 80px;*/
  font-size: 24px;
  font-family: 'fontNormal';
  overflow: hidden;
  pointer-events: all;
}

.warn_inner {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 650px;
  width: 550px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url('img/warn.png');
}

.warn_content {
  position: absolute;
  width: 460px;
  padding: 5px 30px 0px 15px;
  top: 290px;
  left: 55px;
  color: #f8f4f0;
  word-break: break-all;
}

.warn_label {
  font-size: 22px;
  color: #f9efe5;
}

.warn_val {
  font-size: 26px;
  color: #ffff00;
  font-weight: bolder;
  font-family: 'fontNormal';
}

.factorySubLeft {
  left: 800px;
  top: 0px;
  height: 0px;
  -webkit-animation: warn 3s linear;
  animation: warn 3s linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.warnTicket {
  right: 645px;
  top: 160px;
  transform: scale(0) rotateY(-360deg);
}

.warn1-large {
  right: 1200px;
  transform: scale(1) rotateY(0deg) !important;
  transition: all 0.75s linear 0s;
  transition-delay: 1s;
}

.factorySubRight {
  right: 800px;
  top: 140px;
  height: 0px;
  -webkit-animation: warn 3s linear;
  animation: warn 3s linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@keyframes warn {
  0% {
    height: 0px;
  }
  100% {
    height: 650px;
  }
}

.alarm_bar {
  position: absolute;
  transform: translate3d(100px, 100px, 100px);
  width: 600px;
  height: 0px;
  font-family: 'fontNormal';
  border-radius: 10px;
  /*background-image: url("img/warnBg.png");*/
  //overflow: hidden;
  padding: 0px;
  pointer-events: all;
}

.alarm_inner {
  overflow: hidden;
  font-size: 22px;
  height: 300px;
  width: 600px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 25px 20px;
  position: absolute;
  font-family: 'fontNormal';
  margin-top: 0px;
  width: 0px;
  -webkit-animation: move 1.5s linear;
  animation: move 1.5s linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  background-image: url(img/2.png);
}

.alarm_inner > p {
  padding: 5px 0;
  width: 550px;
}

.emission_alarm {
  font-size: 22px;
  /* margin-top: -10px; */
  width: 50% !important;
  text-align: center !important;
  bottom: 30px;
  right: 0px;
  position: absolute;
  color: #aaa;
}

.emission_bar {
  color: #57eaf8 !important;
  font-size: 50px !important;
  text-align: center;
  margin: 30px 0 0 -30px;
}

.emission_title {
  color: #cccccc !important;
  font-size: 20px !important;
  text-align: center;
  margin: 0px 0px 0px -90px;
}

.leftAlarm {
  left: 1372px;
  height: 300px;
  top: 390px;
  transform: translate3d(0px, 0px, 180px) rotateY(0deg) rotateX(0deg);
}

.emission_img {
  position: absolute;
  left: 0px;
  bottom: 30px;
  width: 72px !important;
  height: 92px;
  margin-left: 110px;
  background-image: url('img/1.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

@keyframes move {
  0% {
    width: 0px;
  }
  100% {
    width: 600px;
  }
}

.bolderFont {
  font-weight: bolder;
  font-family: 'fontNormal';
  font-size: 26px;
  color: #ffd9af;
  margin-left: 15px;
  margin-right: 15px;
}

.rightAlarm {
  right: 1360px;
  height: 380px;
  top: 350px;
  transform: translate3d(0px, 0px, 90px) rotateY(-30deg) rotateX(0deg);
}

.left {
  /*transform: translate3d(800px, 260px, 90px) rotate3d(0, 1, 0, 85deg);*/
  transform: translate3d(800px, 0px, 90px) rotateY(85deg) rotateX(0deg);
  left: 0px;
  top: 300px;
}

.right {
  /*transform: translate3d(800px, 260px, 90px) rotate3d(0, 1, 0, -15deg);*/
  transform: translate3d(-800px, 0px, 90px) rotateY(-85deg) rotateX(0deg);
  right: 0px;
  top: 300px;
}

.warnLeft {
  transform: translate3d(800px, 200px, 0px) rotate3d(0, 1, 0, 0deg);
  top: 0px;
  left: 0px;
}

.warnRight {
  transform: translate3d(-800px, 200px, 0px) rotate3d(0, 1, 0, 0deg);
  top: 0px;
  right: 0px;
}

.number {
  font-family: 'number';
  padding: 0 10px;
  font-weight: bolder;
  color: #e8eaed;
  font-size: 30px;
}

.description {
  position: relative;
  margin: 2px 0;
  color: #e8eaed;
  font-size: 22px;
  display: block;
}

.factory_bar p {
  color: #e8eaed;
  padding: 7px;
  text-shadow: -12px -12px 8px rgb(255 255 255 / 30%);
}
.factorySub_bar p {
  color: #ffff00;
  padding: 5px;
}

.title_color {
  color: #dcc59f;
  margin: -15px 0 5px 0;
  position: relative;
  /*display: block;*/
}

.treatment_bar {
  color: #50eafb;
  /*background: rgba(0, 0, 0, 0.6);*/
  width: 100%;
  border-radius: 5px;
  padding: 20px 15px;
  text-shadow: -8px -8px 8px rgb(80 234 251 / 30%);
  /*box-shadow: 1px 1px 10px rgb(255 255 255 / 60%);*/
}

.left {
  .factory_title {
    margin-left: -5%;
  }
}

.factory_title {
  font-weight: bolder;
  font-size: 46px;
  margin-top: -80px;
  position: absolute;
  font-family: 'fontNormal';
  width: 80%;
  text-align: center;
  text-shadow: -8px -8px 8px rgb(255 255 255 / 50%);
}

.factorySub_title {
  font-weight: bolder;
  left: 60px;
  right: 80px;
  text-align: center;
  font-size: 45px;
  margin-top: -100px;
  position: absolute;
}

.treatment_rate {
  font-weight: bolder;
  right: 120px;
  font-size: 42px;
  color: #eee !important;
  margin-top: -85px;
  position: absolute;
}

.factory_bar_shadow {
  background: -webkit-linear-gradient(top, rgb(0, 0, 0) 50%, rgba(255, 255, 255, 0)) center center / 100% 100%,
    url('img/panelView_blueBg_3_3.png');
}

.yy {
  position: absolute;
  left: 0;
  top: 350px;
  width: 200px;
  height: 300px;
  transform: scale(1, -1);
  opacity: 0.3;
  border-radius: 5px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
  position: absolute;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url('/static/images/common/overal.png');
  background-size: 100% 100%;
  background-repeat: 'no-repeat';
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url('/static/images/common/overal.png');
  background-size: 100% 100%;
  background-repeat: 'no-repeat';
  z-index: -1;
}

.changeSet {
  display: block;
  height: 100px;
  width: 100px;
  background: black;
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: all;
}
</style>

<style lang="scss" scoped>
.switch-btn {
  position: absolute;
  margin-left: 120px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: bolder;
  font-size: 22px;
  z-index: 999;
  padding: 3px 16px;
}
.switch-btn_ {
  position: absolute;
  color: rgba(255, 255, 255, 0.8);
  font-weight: bolder;
  font-size: 22px;
  z-index: 999;
  padding: 3px 16px;
}
.switch-btn-active {
  /*color: #fbd4a2;*/
  background: #c8d8ff;
  color: #000;
}
.cta {
  display: flex;
  padding: 10px 45px;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
  font-size: 32px;
  color: white;
  background: rgba(255, 255, 255, 0.25);
  transition: 1s;
  box-shadow: 6px 6px 0 black;
  transform: skewX(-15deg) scale(0.85);
  transform-origin: top right;
  position: absolute;

  pointer-events: all;
  font-family: 'fontNormal';

  span {
    -webkit-transform: skewX(15deg);
    transform: skewX(15deg);
  }

  span:nth-child(2) {
    width: 20px;
    margin-left: 30px;
    position: relative;
    top: 12%;
  }
}

.cta0 {
  bottom: 425px;
  background: url(./img/router-btn.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  right: 90px;
  position: absolute;
  perspective: 1000px;
  height: 70px;
  line-height: 70px;
  border-radius: 20px;
  transform: scale(0.85) !important;
  span {
    transform: skewX(0) !important;
  }
}

.cta0_report {
  bottom: 440px;
  right: 325px;
  position: absolute;
  perspective: 1000px;
  pointer-events: all;
  cursor: pointer;
  img {
    display: block;
    width: 70px;
    box-shadow: 6px 6px 0 black;
    border-radius: 50px;
  }
}

.cta1 {
  bottom: 325px;
  background: url(./img/router-btn.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  right: 50px;
  position: absolute;
  perspective: 1000px;
  height: 70px;
  line-height: 70px;
  border-radius: 20px;
  transform: scale(0.85) !important;
  span {
    transform: skewX(0) !important;
  }
}

.cta1_report {
  bottom: 340px;
  right: 340px;
  position: absolute;
  perspective: 1000px;
  pointer-events: all;
  cursor: pointer;
  img {
    display: block;
    width: 70px;
    box-shadow: 6px 6px 0 black;
    border-radius: 50px;
  }
}

.cta2 {
  bottom: 220px;
  background: url(./img/router-btn.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  right: 90px;
  position: absolute;
  perspective: 1000px;
  height: 70px;
  line-height: 70px;
  border-radius: 20px;
  transform: scale(0.85) !important;
  span {
    transform: skewX(0) !important;
  }
}

.cta3 {
  bottom: 115px;
  background: url(./img/router-btn.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  right: 135px;
  position: absolute;
  perspective: 1000px;
  height: 70px;
  line-height: 70px;
  border-radius: 20px;
  transform: scale(0.85) !important;
  span {
    transform: skewX(0) !important;
  }
}

.cta2_report {
  bottom: 240px;
  right: 355px;
  position: absolute;
  perspective: 1000px;
  pointer-events: all;
  cursor: pointer;
  img {
    display: block;
    width: 70px;
    box-shadow: 6px 6px 0 black;
    border-radius: 50px;
  }
}

.cta3_report {
  bottom: 140px;
  right: 370px;
  position: absolute;
  perspective: 1000px;
  pointer-events: all;
  cursor: pointer;
  img {
    display: block;
    width: 70px;
    box-shadow: 6px 6px 0 black;
    border-radius: 50px;
  }
}

.cta:focus {
  outline: none;
}

.cta:hover {
  transition: 0.5s;
  box-shadow: 10px 10px 0 #fbc638;
}

.cta span:nth-child(2) {
  transition: 0.5s;
  margin-right: 0px;
}

.cta:hover span:nth-child(2) {
  transition: 0.5s;
  margin-right: 45px;
}

/**************SVG****************/

path.one {
  transition: 0.4s;
  -webkit-transform: translateX(-60%);
  transform: translateX(-60%);
}

path.two {
  transition: 0.5s;
  -webkit-transform: translateX(-30%);
  transform: translateX(-30%);
}

.cta:hover path.three {
  -webkit-animation: color_anim 1s infinite 0.2s;
  animation: color_anim 1s infinite 0.2s;
}

.cta:hover path.one {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
  -webkit-animation: color_anim 1s infinite 0.6s;
  animation: color_anim 1s infinite 0.6s;
}

.cta:hover path.two {
  -webkit-transform: translateX(0%);
  transform: translateX(0%);
  -webkit-animation: color_anim 1s infinite 0.4s;
  animation: color_anim 1s infinite 0.4s;
}

/* SVG animations */

@-webkit-keyframes color_anim {
  0% {
    fill: white;
  }
  50% {
    fill: #fbc638;
  }
  100% {
    fill: white;
  }
}

@keyframes color_anim {
  0% {
    fill: white;
  }
  50% {
    fill: #fbc638;
  }
  100% {
    fill: white;
  }
}
</style>

<style scoped lang="scss">
.allListBtn {
  color: #4be0ff;
  position: absolute;
  right: 50px;
  top: 50px;
}

.green-dot {
  color: #99f5ffff;
  line-height: 16px;
  font-size: 30px;
}

.red-dot {
  color: #ff7f7fff;
  line-height: 16px;
  font-size: 30px;
}

.gray-dot {
  color: #cccccccc;
  line-height: 16px;
  font-size: 30px;
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #4d4d4dff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: 'fontNormal';
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
